import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import { withRouter, useHistory } from "react-router-dom";
import { store } from "react-notifications-component";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import {
    NavBarContainer,
    HeadMenu,
    Items,
    ItemMenu,
    DropSubItems,
    SubItem,
    FooterMenu,
    ItemFootMenu,
    Terms,
    Plans,
    MenuHamburg,
    Notification,
    NumNotifications,
    Upgrade,
    BtnMinimize,
    ButtonNewP,
    ImgGooglePlay,
    NotificationBadge,
} from "./styles";

import Tooltip from "../tooltip";

import * as S from "./styles"

import { useHeaderMenu } from "../../contexts/HeaderMenuContext";

import iconCompanyTotvsWhite from "../../assets/icons/totvs/icon-totvs-company-white.png";
import iconCompanyTotvsGray from "../../assets/icons/totvs/icon-totvs-company-gray.png";

import iconUsersTotvsGray from "../../assets/icons/totvs/icon-totvs-users-gray.png";
import iconUsersTotvsWhite from "../../assets/icons/totvs/icon-totvs-users-white.png";

import iconGlobalTotvsGray from "../../assets/icons/totvs/icon-totvs-global-gray.png";
import iconGlobalTotvsWhite from "../../assets/icons/totvs/icon-totvs-global-white.png";

import iconSecurityUserWhite from "../../assets/icons/totvs/icon-security-user-white.png";
import iconSecurityUserGray from "../../assets/icons/totvs/icon-security-user-gray.png";

import iconConfigGray from "../../assets/icons/totvs/icon-config-gray.png";
import iconConfigWhite from "../../assets/icons/totvs/icon-config-white.png";

import Logo from "../../assets/logo.png";
import DispGooglePlay from "../../assets/icons/disponivel-google-play.svg";
import Welcome from '../../assets/welcome.svg';
import DispAppStore from "../../assets/icons/disponivel-app-store.svg";
import MenuHamburger from "../../assets/icons/menu-hamburger.png";
import Arrow from '../../assets/icons/icons-8-expand-arrow@3x.png';
import IconHome from "../../assets/icons/iconHome";
import IconReceita from "../../assets/icons/iconReceita";
import IconFicha from "../../assets/icons/iconFicha";
import IconGuia from "../../assets/icons/iconGuide";
import IconResponsavel from '../../assets/icons/iconFarmer';
import IconProdutor from '../../assets/icons/iconProdutor';
import IconAdd from '../../assets/icons/iconAdd';
import IconRelatorios from '../../assets/icons/iconRelatorios';
import IconExtra from '../../assets/icons/iconExtra';
import IconBuoy from '../../assets/icons/iconBuoy';
import IconNotification from '../../assets/icons/iconNotification';
import IconBlog from '../../assets/icons/iconBlog';
import IconCrm from '../../assets/icons/iconCrm';
import ModalTermos from '../../components/modal/modalTextCheckbox';
import IconSchedule from '../../assets/icons/iconSchedule';
import Seta from '../../assets/icons/seta';
import ModalImage from '../../assets/modalTesteGratis.png';
import ModalImageRecursoCliente from '../../assets/modalRecursoClientes.svg';

import ModalTermosUso from '../modal/modalTermos';
import ModalPolitica from '../modal/modalPoliticas';
import ModalTextSession from '../modal/modalText';
import ModalBloqueio from '../modal/modalGeneric';
import ModalGeneric from '../modal/modalGeneric';
import { checkSession, logout, validaIsTest, validateTest } from '../../services/auth';
import Button from '../button/index';
import ButtonV2 from '../button/button_v2';
import Userinfo from './userinfo';
import IconDiamond from '../../assets/icons/diamond';
import ProfileMenu from '../ProfileAccordion';

import Logo1 from '../../assets/logos/1';
import Logo2 from '../../assets/logos/2';
import Logo3 from '../../assets/logos/3';
import Logo4 from '../../assets/logos/4';
import Logo5 from '../../assets/logos/5';
import Logo6 from '../../assets/logos/6';
import Logo7 from '../../assets/logos/7';
import logomini from '../../assets/logo-mini.png'
import LogoBranca from '../../assets/logo-agroreceita-branco.svg';
import { IconClima } from '../../assets/icons/clima';
import Notificacao from '../../assets/icons/icon-bell-white.png';
import NotificacaoGray from '../../assets/icons/icon-bell-gray.png';
import MenuHamburgerBlack from "../../assets/icons/icon-menu-hamburguer-black.svg";


import { theme } from '../../styles/theme';
import { Auxiliar, BodyG, BodyGSpan, H5 } from '../../styles/stylesTypography';
import maintainUtm from '../../services/maintainUtm';
import ModalReativacao from '../modal/modalReativacao';
import { getIsClienteAntigo } from '../../services/bloqueioAcesso';
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";
import NavbarMobile from '../NavbarMobile';
import { isTotvs, isOmie } from '../../services/globalFunctions';

export const USER = "@userinfo";
export const OPEN = "@open";
export const TERM = "@terms";
export const logged = '@logged';
export const GOOGLE_EMAIL = '@agroreceita_google_email';
export const GOOGLE_USER = '@agroreceita_google_user';
export const GOOGLE_USER_PROFILE = '@agroreceita_google_user_profile';

/**
 * Receita complementar (MT/SISDEV), Nacional (TRT/CFTA), SP (Contratos/CDA-SP),
 * as páginas de relatório (PR/RS/BA/MG, ex. /exportar-defesas/relatorio/PR) e as
 * páginas de contato de órgão para estados sem integração (ex. /exportar-defesas/orgao/RN):
 * não são UFs cadastradas separadamente no plano — o plano costuma liberar por UF,
 * ex. /exportar-defesas/MT. Esses fluxos antes abriam como modal dentro de
 * /exportar-defesas (sem gate própria); agora que são páginas próprias, liberamos
 * com base no mesmo acesso a /exportar-defesas.
 */
const isPlanScreenAllowed = (normalizedPath, screens) => {
    if (!screens?.length) return false;
    if (screens.includes(normalizedPath)) return true;
    if (normalizedPath === '/exportar-defesas/COMPLEMENTAR' ||
        normalizedPath === '/exportar-defesas/nacional' ||
        normalizedPath === '/exportar-defesas/sp' ||
        /^\/exportar-defesas\/relatorio(\/nf)?\/[A-Z]{2}$/.test(normalizedPath) ||
        /^\/exportar-defesas\/orgao\/[A-Z]{2}$/.test(normalizedPath)) {
        return screens.some(
            (s) =>
                typeof s === 'string' &&
                (s === '/exportar-defesas' ||
                    /^\/exportar-defesas\/[A-Z]{2}$/.test(s) ||
                    s === '/exportar-defesas/COMPLEMENTAR'),
        );
    }
    return false;
};

const shouldStartHidden = (path) => {
    const hiddenRoutes = [
        '/login',
        '/compra/sucesso',
        '/cadastro',
        '/cadastro/free',
        '/cadastro/sucesso',
        '/cadastro-completo',
        '/cadastro-email',
        '/validador',
        '/apresentacao',
        '/receituario-agronomico-2026',
        '/receituario-agronomico-2026b',
        '/planos',
        '/termos-de-uso',
        '/politica-de-privacidade',
        '/nova-home/apresentacao',
        '/checkout',
        '/checkout/sucesso',
        '/checkout/parceiros',
        '/checkout/parceiros/sucesso',
        '/lp-indique-e-ganhe',
        '/compendio-gratis',
        '/abrir-app'
    ];

    const hiddenRoutePatterns = [
        /^\/senha\/[^/]+$/,
        /^\/receituario-agronomico-\d{4}[a-z]?$/,
        /^\/simulacaoplano(\/.*)?$/,
    ];

    const normalizedPath = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;

    return hiddenRoutes.includes(normalizedPath) || hiddenRoutePatterns.some((pattern) => pattern.test(normalizedPath));
};

const Navbar = ({ isBlackNovember, hasTopBanner, ...props }) => {

    // Cabeçalhos de página (HeaderV2/GenericUpper) agora podem renderizar o
    // próprio ícone de hambúrguer na mesma linha do título/botão de plano;
    // quando isso acontece, a Navbar não desenha o dela (evita duplicar).
    const { registerMenuOpenHandler, hasInlineMenuButton } = useHeaderMenu();

    //Configurações do MENU
    const [ref] = useState(useRef());
    // const [hide, setHide] = useState(true);
    const [hide, setHide] = useState(() => shouldStartHidden(window.location.pathname));
    const [showDelayedModal, setShowDelayedModal] = useState(false);
    const [showModalBlockDefesas, setShowModalBlockDefesas] = useState(false);

    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    );
    const [isOpen, setIsOpen] = useState(
        typeof window !== 'undefined' ? window.innerWidth > 768 : true
    );

    const [pathname, setPathname] = useState('');
    const [allowedScreens, setAllowedScreens] = useState([]);
    const [permissionsLoaded, setPermissionsLoaded] = useState(false);
    const [widthSize, setWidthSize] = useState(
        typeof window !== 'undefined' ? document.body.clientWidth + 8 : 0
    );

    const [planId, setPlanId] = useState(0);
    const [username, setUsername] = useState(0);
    const [isTest, setIsTest] = useState(false);
    const [isPrePago, setIsPrePago] = useState(false);
    const [userPermission, setUserPermission] = useState(0);
    const [userStatusContrato, setUserStatusContrato] = useState('');
    const [userLogado, setUserLogado] = useState('');
    //const [tourOpen, setTourOpen] = useState(false);

    //Configurações de opções do menu
    const [openReceituario, setOpenReceituario] = useState(false);
    const [openResponsavel, setOpenResponsavel] = useState(false);
    const [openProdutor, setOpenProdutor] = useState(false);
    const [openExtras, setOpenExtras] = useState(false);
    const [openUserOptions, setOpenUserOptions] = useState(false);

    //Notificações
    const [qtd_notification, setQtd_notification] = useState(0);
    const [canPlayAudio, setCanPlayAudio] = useState(false);
    const [showExportarDefesas, setShowExportarDefesas] = useState(false);
    const [exportNotificationStatus, setExportNotificationStatus] = useState(0);

    //Exibição de MODAIS
    const [showModalTermo, setShowModalTermo] = useState(false);
    const [showModalPolitica, setShowModalPolitica] = useState(false);
    const [showModalSession, setShowModalSession] = useState(false);
    const [showModalBloqueio, setShowModalBloqueio] = useState(false);
    const [showModalBloqueioTesteGratis, setShowModalBloqueioTesteGratis] = useState(false);
    const [showModalBloqueioLiberacao, setShowModalBloqueioLiberacao] = useState(false);
    const [showModalBloqueioPlanos, setShowModalBloqueioPlanos] = useState(false);
    const [showModalCancelado, setShowModalCancelado] = useState(false);
    const [showModalHoje, setShowHoje] = useState(false);
    const [showModalVencido, setShowVencido] = useState(false);
    const history = useHistory();
    //const [tour, setTour] = useState(false);
    const [showModalLoggedTrial, setShowModalLoggedTrial] = useState(false);
    //const [tourIndex, setTourIndex] = useState(0);

    //Configuração de modais de bloqueio
    const [titleModal, setTitleModal] = useState('');
    const [messageModal, setMessageModal] = useState('');
    const [modalItems, setModalItems] = useState([]);

    const [contrato, setContrato] = useState([]);

    //Termos
    const [showTerms, setShowTerms] = useState(false);
    const [showUpdateTerms, setShowUpdateTerms] = useState(false);
    const [isRenderComponent, setIsRenderComponent] = useState(false);

    //Totvs 
    const [user] = useState(JSON.parse(localStorage.getItem(USER)));

    const [styleTitleModal] = useState({
        fontFamily: 'Lato',
        fontSize: '22px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        width: '100%',
        textAlign: 'center',
        alignSelf: 'center'
    });

    const [width, setWidth] = useState(window.innerWidth);

    const [styleTextModal] = useState({
        color: 'rgb(48, 56, 72)',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 'normal',
        width: '100%',
        textAlign: 'center',
        alignSelf: 'center'
    });

    const [fullScreens] = useState([
        'login',
        'login-compra',
        'compra',
        'cadastro',
        'senha',
        'simulacaoplano',
        'checkout',
        'compendio-gratis',
        'validador',
        'tour',
        '/receituario-agronomico-2026',
        '/receituario-agronomico-2026b',
        'black-november-2024',
        'planos',
        'termos-de-uso',
        'politica-de-privacidade',
        'novo-login',
        'novo-cadastro',
        'novo-cadastro-email',
        'novo-cadastro/sucesso',
        'novo-cadastro-completo',
        'nova-home/apresentacao',
        'nova-senha',
        '/abrir-app'
    ])

    const publicLinksWithoutModalBlocking = [
        '/indique-e-ganhe',
        '/planos',
        '/termos-de-uso',
        '/politica-de-privacidade',
        '/compendio-gratis',
        "/cadastro",
        "/cadastro/site",
        "/cadastro/free",
        "/cadastro/sucesso",
        "/apresentacao",
        /^\/senha\/[a-zA-Z0-9]+$/,
        "/validador",
        "/linkedin/login",
        '/receituario-agronomico-2026',
        '/receituario-agronomico-2026b',
        /^\/login-compra\/\d+$/,
        /^\/simulacaoplano\/\d+$/,
        /^\/checkout\/\d+$/,
        "/checkout/parceiros",
        "/checkout/parceiros/sucesso",
        "/login",
        "/lgpd",
        "/abrir-app"
    ];

    const privateLinksWithoutModalBlocking = [
        '/cupom-indique-e-ganhe',
        '/indique-e-ganhe',
        '/exportar-defesas',
        /^\/exportar-defesas\/([A-Z]{2}|COMPLEMENTAR|nacional|sp)$/,
        /^\/exportar-defesas\/relatorio(\/nf)?\/[A-Z]{2}$/,
        /^\/exportar-defesas\/orgao\/[A-Z]{2}$/,
        /^\/exportar-defesas\/([A-Z]{2}|COMPLEMENTAR)$/,
        '/gerenciar-plano',
        '/integracao',
        '/integracao-webhook'
    ];

    const closeTerms = () => {
        setShowTerms(false);
        setShowUpdateTerms(false);

        let term = JSON.parse(localStorage.getItem(TERM));

        if (term == 0) {
            props.history.push('/login');
        }
    }

    const updateTerms = async (resposta) => {
        try {
            let user = JSON.parse(localStorage.getItem(USER));

            const payload = {
                username: user.username,
                termos: resposta,
                type: 1
            }
            const response = await api.post(`/termos`, payload);

            localStorage.setItem(TERM, JSON.stringify(1));

            closeTerms();

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-582 Concorde com os termos de uso e políticas de privacidade para prosseguir - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    useEffect(() => {
        if (!isRenderComponent) {
            setIsRenderComponent(true);

            let terms = JSON.parse(localStorage.getItem(TERM));

            if (terms === 0) {
                setShowTerms(true);
            } else if (terms === 2) {
                setShowUpdateTerms(true);
            }
        }
    }, [isRenderComponent]);

    useEffect(() => {
        const hydrateExportarDefesas = async () => {
            let available = false;
            try {
                const user = JSON.parse(localStorage.getItem(USER));
                if (user && user.agro_subsidiary_id) {
                    const resDefesas = await api.get(`/relatorios/defesas/receitas/${user.agro_subsidiary_id}`);
                    const resNf = await api.get(`/relatorios/defesas/nf/${user.agro_subsidiary_id}`);
                    const dataDefesas = resDefesas?.data?.data || [];
                    const dataNf = resNf?.data?.data || [];
                    if (Array.isArray(dataDefesas) && dataDefesas.length > 0 || Array.isArray(dataNf) && dataNf.length > 0) {
                        available = true;
                    }
                }
            } catch (e) { }
            setShowExportarDefesas(available);

            try {
                const user = JSON.parse(localStorage.getItem(USER));
                if (user && user.agro_subsidiary_id) {
                    const resNotif = await api.get("/notificacoes/exportacao");
                    setExportNotificationStatus(resNotif.data.data.status || 0);
                }
            } catch (e) {
            }

        };
        hydrateExportarDefesas();
    }, []);

    const currentPath = window.location.pathname;
    const is404 = localStorage.getItem("is404") === "true";

    const publicLinksModalBlockedOff = publicLinksWithoutModalBlocking.some(link =>
        (typeof link === "string" ? link === currentPath : link.test(currentPath)) || is404
    );

    const privateLinksModalBlockedOff = privateLinksWithoutModalBlocking.some(link =>
        (typeof link === "string" ? link === currentPath : link.test(currentPath)) || is404
    );

    const logincompra = /\/login-compra\//g;
    const simulacaocompra = /\/simulacaoplano\//g;

    const redirectTo = (link, id) => {
        props.history.push(link);

        if (
            link == '/' ||
            link == '/documentos_seguranca' ||
            link == '/solicitar' ||
            link == '/relatorios'
        ) {
            setOpenReceituario(false);
            setOpenResponsavel(false);
            setOpenProdutor(false);
        }

        setOpenUserOptions(false);
    }

    const redirectToBlank = (link) => {
        window.open(link);
    }

    const openMenu = (id) => {
        setIsOpen(true);
        if (id === 1) {
            setOpenReceituario(!openReceituario);
            setOpenResponsavel(false);
            setOpenProdutor(false);
            setOpenExtras(false);
            //setTourIndex(!openReceituario);
        } else if (id == 2) {
            setOpenResponsavel(!openResponsavel);
            setOpenReceituario(false);
            setOpenProdutor(false);
            setOpenExtras(false);
        } else if (id == 3) {
            setOpenProdutor(!openProdutor)
            setOpenReceituario(false);
            setOpenResponsavel(false);
            setOpenExtras(false);
        } else if (id == 4) {
            setOpenExtras(!openExtras);
            setOpenReceituario(false);
            setOpenResponsavel(false);
            setOpenProdutor(false);
        }
    }

    const openModelTerm = () => {
        setShowModalTermo(!showModalTermo);
    }

    const openPolicyTerm = () => {
        setShowModalPolitica(!showModalPolitica);
    }

    const closeAllTabs = (e) => {

        setOpenReceituario(false);
        setOpenResponsavel(false);
        setOpenProdutor(false);
        setOpenExtras(false);

        if (isMobile) {
            setIsOpen(false);
        }

        props.isClosed();
    }

    const closeSession = () => {
        setShowModalSession(false);
        window.location = '/login';
    }

    // const validateSession = async () => {
    //     let isValid = await checkSession();
    //     if (!isValid) {
    //         setShowModalSession(true);
    //     }
    // }

    const getScreenPermissions = () => {
        let permissions = JSON.parse(localStorage.getItem(USER));

        setUserLogado(permissions);

        if (permissions && permissions !== null) {
            if (permissions.contrato) {
                setContrato(permissions.contrato);

                let plan = permissions.contrato.agro_plan_config.agro_plan_id;
                setPlanId(plan);

                let user = permissions.name;
                setUsername(user);

                permissions = permissions.contrato.agro_plan_permissions;

                let permitidos = [];

                permissions.map((screen) => {
                    if (screen.status === 1) {
                        permitidos = [...permitidos, screen.link];
                    }
                })

                setAllowedScreens(permitidos);
                setPermissionsLoaded(true);
            } else {
                localStorage.removeItem(GOOGLE_EMAIL);
                localStorage.removeItem(GOOGLE_USER);
                localStorage.removeItem(GOOGLE_USER_PROFILE);

                logout();
                window.location = '/login';
            }
        }

    }

    const goToHome = () => {
        setShowModalBloqueio(false);
        setShowModalBloqueioLiberacao(false);
        setShowModalBloqueioTesteGratis(false);
        setShowModalBloqueioPlanos(false);
        setShowModalCancelado(false);
        redirectTo('/', 2);
    }

    const getCupomToRedirect = () => {
        const currentCupom = new URLSearchParams(window.location.search).get('cupom');

        if (currentCupom && currentCupom !== 'null') {
            return currentCupom;
        }

        return 'BEMVINDO';
    }

    const goToPlansWithCupom = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        setShowModalLoggedTrial(false);
        localStorage.setItem(OPEN, "true");
        const cupom = encodeURIComponent(getCupomToRedirect());
        window.location = `/planos?cupom=${cupom}${maintainUtm(`${currentPageId}-modalterminaemxdias`, true, ["cupom"])}`;
    }

    const goToPlansWithCupomHoje = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        setShowHoje(false);
        localStorage.setItem(OPEN, "true");
        const cupom = encodeURIComponent(getCupomToRedirect());
        window.location = `/planos?cupom=${cupom}${maintainUtm(`${currentPageId}-modalterminahoje`, true, ["cupom"])}`;
    }

    const goToPlansWithCupomTerminou = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        setShowModalBloqueioTesteGratis(false);
        localStorage.setItem(OPEN, "true");
        const cupom = encodeURIComponent(getCupomToRedirect());
        window.location = `/planos?cupom=${cupom}${maintainUtm(`${currentPageId}-modalterminou`, true, ["cupom"])}`;
    }

    const goToPlans = () => {
        setShowModalBloqueioTesteGratis(false);
        setShowModalBloqueio(false);
        setShowModalLoggedTrial(false);
        const currentPageId = getCurrentPageIdWithDevice();
        redirectTo(`/planos${maintainUtm(`${currentPageId}-modalrecursoexclusivo`)}`, 3);
    }

    const showModalFalse = () => {
        setShowDelayedModal(false);
        localStorage.setItem(OPEN, "true");
    }


    const showModalHojeFalse = () => {
        setShowHoje(false);
        localStorage.setItem(OPEN, "true");
    }
    const goToPlansReativar = () => {
        setShowModalBloqueioTesteGratis(false);
        window.location = '/planos?button=web-modal-reativar';
    }

    const openConsultorWhatsapp = () => {
        window.open('https://wa.me/5515996577718', '_blank');
    }

    // Modal de reativacao: conta com pagamento confirmado e assinatura inativa.
    // Ex-cliente nao pode mais usar cupom de primeira compra, entao nao ha desconto aqui.
    const montarModalReativacao = (inativoDesde) => (
        <S.Container>
            <ModalReativacao
                inativoDesde={inativoDesde}
                onReativar={goToPlansReativar}
                onFalarConsultor={openConsultorWhatsapp}
            />
        </S.Container>
    );

    const validaTesteGratis = async (link, id) => {
        const isValid = await validateTest();

        const isTeste = await validaIsTest();

        const blockedLinks = [
            '/receitas/add',
            '/receitas/addlote',
            '/receitas/add/',
            '/documentos_seguranca',
            '/relatorios',
            '/filiais/add',
            '/',
            '/historico',
            '/agronomos/add',
            '/arts/add',
            '/produtores/add/',
            '/produtores/add',
            '/devolucoes/add',
            '/solicitar',
            '/guia_aplicacao',
        ];

        // Reativacao: a conta ja teve pagamento confirmado (GET /compra/is-cliente) e o
        // plano atual voltou a ser o teste gratis - ou seja, a assinatura paga encerrou.
        // A rota e consultada a cada acesso a uma rota bloqueada, inclusive a home, sem
        // cache e sem olhar dias_restante.
        if (blockedLinks.includes(link)) {
            const { isCliente: clienteAntigo, inativoDesde } = await getIsClienteAntigo();

            if (clienteAntigo && isTeste) {
                setMessageModal(montarModalReativacao(inativoDesde));

                if (publicLinksModalBlockedOff || privateLinksModalBlockedOff) {
                    setShowModalBloqueioTesteGratis(false);
                } else {
                    setShowModalBloqueioTesteGratis(true);
                }

                return;
            }
        }

        if (isTeste) {
            if (isValid) {
                //redirectTo(link, 4);
                let user = JSON.parse(localStorage.getItem(USER));
                let isLogged = localStorage.getItem(logged);

                if (user.contrato.agro_plan_config.agro_plan_id === 1) { //é teste grátis
                    if (isLogged === false || isLogged === 'false') {
                        const open = localStorage.getItem(OPEN);
                        if (open === 'false') {
                            // localStorage.setItem(OPEN, "true");
                        }
                    } else {
                        if (user.contrato.dias_restante <= 14 && user.contrato.dias_restante > 0) {
                            const open = localStorage.getItem(OPEN);
                            if (open === 'false') {
                                setUserLogado(user);
                                setShowModalLoggedTrial(true);
                                // localStorage.setItem(OPEN, "true");
                            }
                        }
                    }

                    const open = localStorage.getItem(OPEN);
                    if (user.contrato.dias_restante === 0 && open === 'false') {
                        //termina hoje
                        setShowHoje(true);

                    } else if (user.contrato.dias_restante < 0) {
                        //vencido
                        setShowVencido(true);
                    }
                }
            } else {

                if (blockedLinks.includes(link)) {
                    setTimeout(() => {
                        // Nunca pagou e o teste gratis acabou: segue a oferta com cupom.
                        setMessageModal(
                                <S.Container>
                                    <img src={ModalImage} alt='Imagem garota olhando um presente' />

                                    <H5>Seu teste grátis terminou</H5>

                                    <BodyG>
                                        Assine agora mesmo utilizando o cupom <BodyGSpan color={theme.colors.red.Vermelho_erro}>BEMVINDO</BodyGSpan> e garanta <BodyGSpan color={theme.colors.red.Vermelho_erro}>90% de desconto</BodyGSpan> na primeira mensalidade dos planos Basic, Light ou Pro ou <BodyGSpan color={theme.colors.red.Vermelho_erro}>20% de desconto</BodyGSpan> na sua primeira compra de créditos Pré-pago.
                                    </BodyG>

                                    <Auxiliar color={theme.colors.gray.Cinza_6}>
                                        Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                                    </Auxiliar>

                                    <div
                                        className="button-finish"
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                        }}
                                    >
                                        <ButtonV2
                                            width='296px'
                                            height='50px'
                                            value='ASSINAR AGORA'
                                            outline={false}
                                            disabled={false}
                                            onClick={() => goToPlansWithCupomTerminou()}
                                            loading={false}
                                        />
                                    </div>
                                </S.Container>
                        );

                        if (publicLinksModalBlockedOff || privateLinksModalBlockedOff) {
                            setShowModalBloqueioTesteGratis(false);
                        } else {
                            setShowModalBloqueioTesteGratis(true);
                        }
                    }, 500);
                }
            }
        } else {
            localStorage.setItem(OPEN, "true");
        }

    }

    const validaIsMobile = (width) => {
        if (width > 0) {
            if (width <= 768) {
                setIsMobile(true);
                setIsOpen(false);
                props.updateIsFullScreen(true);
                props.updateIsMobile(true);
            } else {
                setIsMobile(false);
                // setIsOpen(true);
                props.updateIsMobile(false);

                let location0 = props.location.pathname.split('/');

                let location1 = `${location0[1]}`;

                if (fullScreens.find(e => e == location1) || publicLinksModalBlockedOff) {
                    let user = JSON.parse(localStorage.getItem(USER));

                    if (location1 === 'compra' && user && user !== null) {
                        if (props.location.pathname === '/compra/sucesso' ||
                            props.location.pathname === "/compra/sucesso/compra-5" ||
                            props.location.pathname === "/compra/sucesso/compra-4" ||
                            props.location.pathname === "/compra/sucesso/compra-7" ||
                            props.location.pathname === "/compra/sucesso/compra-6") {
                            props.updateIsFullScreen(true);
                        } else {
                            props.updateIsFullScreen(false);
                        }
                    } else {
                        props.updateIsFullScreen(true);
                    }
                } else {
                    props.updateIsFullScreen(false);
                }
            }
        }
    }

    const openMenuByHamburger = () => {
        setIsOpen(true);
    }

    useEffect(() => {
        registerMenuOpenHandler(openMenuByHamburger);
    }, []);

    if (logged === true || logged === 'true') {

        const getNotifications = async () => {
            try {
                const response = await api.get(`/notificacoes/quantidade`);
                const qtdr = response.data.data;
                setQtd_notification(qtdr);
            } catch (error) {
            }
        }
    }

    const getPlansConfig = () => {
        let user = JSON.parse(localStorage.getItem(USER));

        if (user && user !== null) {
            if (user.contrato) {

                if (user.contrato.status) {
                    if (user.contrato.status === 'AP') {
                        let is_test = user.contrato.agro_plan_config.is_teste;
                        let is_prePago = user.contrato.agro_plan_config.is_pre_pago;

                        if (is_test === 1) {
                            setIsTest(true);
                        }

                        if (is_prePago === 1) {
                            setIsPrePago(true);
                        }
                    } else {
                        setIsTest(false);
                    }
                } else {
                    localStorage.removeItem(GOOGLE_EMAIL);
                    localStorage.removeItem(GOOGLE_USER);
                    localStorage.removeItem(GOOGLE_USER_PROFILE);

                    logout();
                    window.location = '/login';
                }
            } else {
                localStorage.removeItem(GOOGLE_EMAIL);
                localStorage.removeItem(GOOGLE_USER);
                localStorage.removeItem(GOOGLE_USER_PROFILE);

                logout();
                window.location = '/login';
            }
        }
    }

    const getUserPermission = () => {
        let user = JSON.parse(localStorage.getItem(USER))
        if (user) {
            setUserPermission(user.agro_permission_id);
        }
    }

    // Revalida a assinatura a cada troca de rota - inclusive ao cair na home - para que
    // a consulta de /compra/is-cliente reflita sempre o estado atual, sem cache.
    // Nao e mais gated por @open: aquela flag so controla as modais de boas-vindas do
    // teste gratis, que seguem com as proprias verificacoes dentro de validaTesteGratis.
    const inicializa = () => {
        if (props.location.pathname === '/compra/sucesso' ||
            props.location.pathname === "/compra/sucesso/compra-5" ||
            props.location.pathname === "/compra/sucesso/compra-4" ||
            props.location.pathname === "/compra/sucesso/compra-7" ||
            props.location.pathname === "/compra/sucesso/compra-6") {
            return;
        }

        validaTesteGratis(props.location.pathname || '/', 1);
    }

    useEffect(() => {
        inicializa();
    }, [props.location.pathname])

    const logs = async (pathname) => {
        let pathnameSplit = pathname.split('/')

        if (pathnameSplit[1] == 'previsao_tempo') {
            if (pathnameSplit[2] == undefined) {
                const response = await api.post(`/logs/add`, {
                    id: 118,
                });
            } else {
                const response = await api.post(`/logs/add`, {
                    id: 135,
                    obs: `Fazenda: ${pathnameSplit[2]}`
                });
            }
        } else if (pathnameSplit[1] == 'relatorios') {
            const response = await api.post(`/logs/add`, {
                id: 119,
            });
        } else if (pathnameSplit[1] == 'agenda') {
            const response = await api.post(`/logs/add`, {
                id: 113,
            });
        } else if (pathnameSplit[1] == 'crm') {
            const response = await api.post(`/logs/add`, {
                id: 136,
            });
        } else if (pathnameSplit[1] == 'integracao') {
            const response = await api.post(`/logs/add`, {
                id: 140,
            });
        }

    }

    useEffect(() => {
        if (props.location.pathname === '/compra/sucesso' ||
            props.location.pathname === "/compra/sucesso/compra-5" ||
            props.location.pathname === "/compra/sucesso/compra-4" ||
            props.location.pathname === "/compra/sucesso/compra-7" ||
            props.location.pathname === "/compra/sucesso/compra-6") {

        } else {
            getScreenPermissions();
            // getNotifications();
            getPlansConfig();

            getUserPermission();

            let width = document.body.clientWidth + 8;  //pegar largura da tela no inicio
            setWidthSize(width);
        }

    }, [])

    useEffect(() => {
        props.isOpen(isOpen);
    }, [isOpen])

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem(USER));
        if (user) {
            setUserStatusContrato(user.contrato.status);
            if (user.contrato.status === 'AP') {
                if (!permissionsLoaded) {
                    return;
                }
                if (allowedScreens.length > 0) {
                    let link = props.location.pathname.trim();

                    link = link.split('/');

                    let newLink = '';

                    link.map((l) => {
                        if (l !== '') {
                            if (!isNaN(parseFloat(l)) && isFinite(l)) {
                                newLink = `${newLink}/:id`;
                            } else {
                                newLink = `${newLink}/${l}`;
                            }
                        }
                    });

                    link = newLink ? newLink : '/';

                    if (!isPlanScreenAllowed(link, allowedScreens)) {
                        if (link === '/login' ||
                            link === '/compra/sucesso' ||
                            link === '/compra/sucesso/compra-5' ||
                            link === '/compra/sucesso/compra-4' ||
                            link === '/compra/sucesso/compra-7' ||
                            link === '/compra/sucesso/compra-6' ||
                            link === '/cadastro' ||
                            link === '/cadastro/free' ||
                            link === '/validador' ||
                            link === '/apresentacao' ||
                            link === '/receituario-agronomico-2026' ||
                            link === '/receituario-agronomico-2026b' ||
                            link === '/black-november-2024' ||
                            link === '/planos' ||
                            link === '/nova-home/apresentacao' ||
                            // link === '/novo-login'  ||
                            // link === '/cadastro' ||
                            link === '/cadastro-completo' ||
                            link === '/cadastro/sucesso' ||
                            link === '/cadastro-email' ||
                            link === '/checkout' ||
                            link === '/checkout/sucesso' ||
                            link === '/checkout/parceiros' ||
                            link === '/checkout/parceiros/sucesso' ||
                            publicLinksModalBlockedOff) {
                            setHide(true);

                            props.updateIsFullScreen(true);
                        } else {

                            setHide(false);

                            if (showModalBloqueioTesteGratis === false && showModalBloqueio === false) {
                                if (!isTest && isTotvs() !== true && props.location.pathname !== '/abrir-app') {
                                    if (props.location.pathname === '/filiais/add') {
                                        setTitleModal("");
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes PRO</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Esta função está disponível apenas para clientes PRO. Para desbloquear essa e outras funcionalidades, faça já seu upgrade.
                                                </BodyG>

                                                <Auxiliar color={theme.colors.gray.Cinza_6}>
                                                    Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                                                </Auxiliar>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >

                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />
                                                </div>
                                            </S.Container>
                                        </>);
                                    } else {
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes PRO</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Esta função está disponível apenas para clientes PRO. Para desbloquear essa e outras funcionalidades, faça já seu upgrade.
                                                </BodyG>

                                                <Auxiliar color={theme.colors.gray.Cinza_6}>
                                                    Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                                                </Auxiliar>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >

                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />
                                                </div>
                                            </S.Container>
                                        </>);
                                    }
                                    // setHide(false);

                                    if (!privateLinksModalBlockedOff) {
                                        setShowModalBloqueio(true);
                                    }
                                } else {
                                    if (isTest) {
                                        validaTesteGratis(props.location.pathname, 2);
                                    }
                                }
                            }

                            if (
                                link === "/" ||
                                link === '/compendio' ||
                                link === "/cupom-indique-e-ganhe" ||
                                link === "/nova-home/apresentacao" ||
                                link === "/nova-farm" ||
                                link === "/produtores" ||
                                link === '/caderno-campo' ||
                                link === '/fazendas/edit/:id/:id') {
                                setShowModalBloqueio(false);
                            }
                        }
                    } else {
                        if (link === '/login' ||
                            link === '/compra/sucesso' ||
                            link === '/compra/sucesso/compra-5' ||
                            link === '/compra/sucesso/compra-4' ||
                            link === '/compra/sucesso/compra-7' ||
                            link === '/compra/sucesso/compra-6' ||
                            link === '/cadastro' ||
                            link === '/cadastro/free' ||
                            link === '/validador' ||
                            link === '/receituario-agronomico-2026' ||
                            link === '/receituario-agronomico-2026b' ||
                            link === '/black-november-2024' ||
                            link === '/planos' ||
                            link === '/nova-home/apresentacao' ||
                            // link === '/novo-login' || 
                            // link === '/novo-cadastro' || 
                            link === '/cadastro-completo' ||
                            link === '/cadastro/sucesso' ||
                            link === '/cadastro-email' ||
                            publicLinksModalBlockedOff) {
                            setHide(true);

                            props.updateIsFullScreen(true);
                        } else {
                            setHide(false);
                            setPathname(props.location.pathname);
                        }
                    }
                } else {
                    setHide(true);
                }

                if (props.closeAllTabs === true) {
                    closeAllTabs(1);
                    setOpenUserOptions(false);
                }
            } else if (user.contrato.status === 'EN') {
                const screensPermitidas = [
                    '/',
                    '/agronomos',
                    '/arts',
                    '/produtores',
                    '/fazendas',
                    '/devolucoes',
                    '/extras/nova_receita',
                    '/usuarios/:id',
                    '/filiais',
                    '/usuarios',
                    '/notificacoes',
                    '/compra/sucesso',
                    '/compra/sucesso/compra-5',
                    '/compra/sucesso/compra-4',
                    '/compra/sucesso/compra-7',
                    '/compra/sucesso/compra-6',
                    '/compendio',
                    '/blog',
                    '/agenda',
                    '/crm',
                    '/login',
                    '/validador',
                    '/nova-home/apresentacao',
                    // '/novo-login',
                    '/cadastro',
                    '/cadastro-email',
                    '/cadastro/sucesso',
                    '/cadastro-completo',
                    '/novo-produtores',
                    '/nova-farm',
                    '/caderno-campo',
                ];

                let link = props.location.pathname.trim();
                link = link.split('/');
                let newLink = '';

                link.map((l) => {
                    if (l !== '') {
                        if (!isNaN(parseFloat(l)) && isFinite(l)) {
                            newLink = `${newLink}/:id`;
                        } else {
                            newLink = `${newLink}/${l}`;
                        }
                    }
                });

                link = newLink ? newLink : '/';

                if (!screensPermitidas.includes(link)) {
                    setTitleModal('Aguardando liberação da conta!');
                    setMessageModal('O acesso completo ao sistema estará liberado após a confirmação do pagamento!');
                    setModalItems([]);

                    setShowModalBloqueioLiberacao(true);
                }
            } else if (user.contrato.status === 'CA') {
                const screensPermitidas = [
                    '/',
                    '/agronomos',
                    '/arts',
                    '/produtores',
                    '/fazendas',
                    '/devolucoes',
                    '/extras/nova_receita',
                    '/usuarios/:id',
                    '/filiais',
                    '/usuarios',
                    '/notificacoes',
                    '/compra/sucesso',
                    '/compra/sucesso/compra-5',
                    '/compra/sucesso/compra-4',
                    '/compra/sucesso/compra-7',
                    '/compra/sucesso/compra-6',
                    '/compendio',
                    '/blog',
                    '/agenda',
                    '/crm',
                    '/login',
                    '/validador',
                    '/nova-home/apresentacao',
                    // '/novo-login',
                    '/cadastro',
                    '/cadastro/sucesso',
                    '/cadastro-completo',
                    '/cadastro/cadastro-email',
                    '/novo-produtores',
                    '/nova-farm',
                    '/caderno-campo',
                ];

                let link = props.location.pathname.trim();
                link = link.split('/');
                let newLink = '';

                link.map((l) => {
                    if (l !== '') {
                        if (!isNaN(parseFloat(l)) && isFinite(l)) {
                            newLink = `${newLink}/:id`;
                        } else {
                            newLink = `${newLink}/${l}`;
                        }
                    }
                });

                link = newLink ? newLink : '/';

                if (!screensPermitidas.includes(link)) {
                    setTitleModal('Contrato cancelado!');
                    setMessageModal('Entre em contato com nosso suporte!');
                    setModalItems([]);

                    setShowModalCancelado(true);
                }
            }
        } else {

        }

    }, [props.location.pathname, props.closeAllTabs, allowedScreens.length, planId])

    useEffect(() => {
        setPathname(props.location.pathname);

        if (props.location.pathname !== '/login' &&
            props.location.pathname !== '/compra/sucesso' &&
            props.location.pathname !== '/compra/sucesso/compra-5' &&
            props.location.pathname !== '/compra/sucesso/compra-4' &&
            props.location.pathname !== '/compra/sucesso/compra-7' &&
            props.location.pathname !== '/compra/sucesso/compra-6' &&
            props.location.pathname !== '/validador') {
            // validateSession();
            // getNotifications();

            let user = JSON.parse(localStorage.getItem(USER))

            if (user) {
                if (props.location.pathname === '/planos' && userPermission > 1) {
                    if (props.match.isExact === false && props.match.url === '/' && props.match.path === '/' && props.location.pathname !== '/relatorios' && props.location.pathname !== '/solicitar' && props.location.pathname !== '/documentos_seguranca' && props.location.pathname !== '/historico' && props.location.pathname !== '/guia_aplicacao') {
                        setHide(true);
                    } else {
                        if (!isTest) {
                            setTitleModal('Essa função não está liberada para o seu tipo de acesso');
                            setMessageModal('Para atualizar seu plano entre em contato com seu administrador matriz!');
                            setHide(false);

                            setShowModalBloqueioPlanos(true);
                        } else {
                            if (isTest) {
                                validaTesteGratis(props.location.pathname, 3);
                            }
                        }
                    }
                } else {
                    if (allowedScreens.length > 0) {

                        let link = props.location.pathname.trim();

                        link = link.split('/');

                        let newLink = '';

                        link.map((l) => {
                            if (l !== '') {
                                if (!isNaN(parseFloat(l)) && isFinite(l)) {
                                    newLink = `${newLink}/:id`;
                                } else {
                                    newLink = `${newLink}/${l}`;
                                }
                            }
                        });

                        link = newLink ? newLink : '/';


                        if (isPlanScreenAllowed(link, allowedScreens)) {

                        } else {
                            if (props.match.isExact === false && props.match.url === '/' && props.match.path === '/' && props.location.pathname !== '/relatorios' && props.location.pathname !== '/solicitar' && props.location.pathname !== '/documentos_seguranca' && props.location.pathname !== '/historico' && props.location.pathname !== '/validador' && props.location.pathname !== '/guia_aplicacao') {
                                setHide(true);
                            } else if (props.location.pathname === '/checkout' || props.location.pathname === '/checkout/sucesso' || props.location.pathname.startsWith('/checkout/parceiros')) {
                                setHide(true);
                            } else {
                                if (!isTest) {
                                    if (props.location.pathname === '/documentos_seguranca') {
                                        setTitleModal('');
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes PRO</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Esta função está disponível apenas para clientes PRO. Para desbloquear essa e outras funcionalidades, faça já seu upgrade.
                                                </BodyG>

                                                <Auxiliar color={theme.colors.gray.Cinza_6}>
                                                    Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                                                </Auxiliar>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >

                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />

                                                    {/* <span
                                                        className='bluelink'
                                                        style={{
                                                            color: 'rgb(88, 155, 255)',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            window.open('https://agroreceita.com.br/ficha-emergencia-fispq', '_blank');
                                                        }}
                                                    >
                                                        Saiba mais
                                                    </span> */}
                                                </div>
                                            </S.Container>
                                        </>);
                                    } else if (props.location.pathname === '/relatorios') {
                                        setTitleModal('');
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes <br /> LIGHT e PRO</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Tenha em mãos os dados das receitas emitidas em relatórios fáceis de entender, visualize os produtos mais comercializados pela sua empresa, efetue o monitoramento dos alvos mais frequentes por cultura e período, entre outros.
                                                </BodyG>

                                                <Auxiliar color={theme.colors.gray.Cinza_6}>
                                                    Faça um upgrade para desbloquear esse recurso.
                                                </Auxiliar>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />

                                                    <span
                                                        className='bluelink'
                                                        style={{
                                                            color: 'rgb(88, 155, 255)',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            window.open('https://sudeste-online.s3.amazonaws.com/relatorios/relatorio.png', '_blank');
                                                        }}
                                                    >
                                                        Ver exemplo dos relatórios
                                                    </span>
                                                </div>
                                            </S.Container>
                                        </>);
                                    } else if (props.location.pathname === '/filiais/add') {
                                        setTitleModal('');
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes PRO</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Esta função está disponível apenas para clientes PRO. Para desbloquear essa e outras funcionalidades, faça já seu upgrade.
                                                </BodyG>

                                                <Auxiliar color={theme.colors.gray.Cinza_6}>
                                                    Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                                                </Auxiliar>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >

                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />
                                                </div>
                                            </S.Container>
                                        </>);
                                    } else {
                                        setTitleModal('');
                                        setMessageModal(<>
                                            <S.Container>
                                                <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                                                <H5 color={theme.colors.gray.Cinza_5}>Essa função não está liberada para o seu plano</H5>

                                                <BodyG color={theme.colors.gray.Cinza_5}>
                                                    Faça um upgrade para desbloquear esse recurso
                                                </BodyG>

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '350px',
                                                        margin: 'auto',
                                                        marginTop: '20px',
                                                        alignSelf: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <ButtonV2
                                                        width='296px'
                                                        height='50px'
                                                        value='VER PLANOS'
                                                        outline={false}
                                                        disabled={false}
                                                        onClick={() => goToPlans()}
                                                        loading={false}
                                                    />
                                                </div>
                                            </S.Container>
                                        </>);
                                    }
                                    setHide(false);

                                    setShowModalBloqueio(true);

                                } else {
                                    if (isTest) {
                                        validaTesteGratis(props.location.pathname, 4);
                                    }
                                }
                            }
                        }
                    }
                }
            }


        } else {
            setOpenUserOptions(false); //fechar opções de usuário
            setHide(true);
            props.updateIsFullScreen(true);
        }

        if (isMobile) {
            setIsOpen(false);
        }
    }, [props.location.pathname, userPermission])

    if (props.location.pathname === '/compra') {
        localStorage.setItem(OPEN, "true");
    }

    // useEffect(() => {
    //     if (pathname && pathname !== '/') {
    //         validateSession();
    //     }
    // }, [pathname])

    useEffect(() => {
        validaIsMobile(widthSize);
    }, [widthSize])

    useEffect(() => {
        const initialWidth = document.body.clientWidth + 8;
        setWidthSize(initialWidth);
        validaIsMobile(initialWidth);
    }, [])

    useEffect(() => {
        if (typeof props.routeConfig?.showMenu === 'boolean') {
            setHide(!props.routeConfig.showMenu);
        }
    }, [props.routeConfig])


    useEffect(() => {
        const handleUserInteraction = () => {
            setCanPlayAudio(true);
            window.removeEventListener("click", handleUserInteraction);
        };

        window.addEventListener("click", handleUserInteraction);
        return () => window.removeEventListener("click", handleUserInteraction);
    }, []);

    useEffect(() => {
        if (qtd_notification > 0 && canPlayAudio && props.location.pathname === '/') {
            const audio = new Audio("/notification.mp3");
            audio.volume = 0.5
            audio.play().catch((err) => {
                console.warn("Erro ao tocar áudio:", err);
            });
        }
    }, [qtd_notification, canPlayAudio, props.location.pathname]);


    useEffect(() => {
        if (props.location.pathname !== '/' && isMobile === false) {
            setIsOpen(true);
            closeAllTabs(2);

            logs(props.location.pathname, 0)
        } else if (props.location.pathname === '/' && isMobile === false) {
            setIsOpen(true);
        }
    }, [props.location.pathname, isMobile])

    //função para capturar evento de movimentar tamanho da janela
    window.onresize = function (event) {
        let width = document.body.clientWidth + 8;
        setWidthSize(width);
    }

    const minimizeMenu = () => {
        setIsOpen(!isOpen);
        closeAllTabs(3);
    }

    useEffect(() => {
        if (showModalLoggedTrial && userLogado) {
            const timer = setTimeout(() => setShowDelayedModal(true), 1000);
            return () => clearTimeout(timer);
        } else {
            setShowDelayedModal(false);
        }
    }, [showModalLoggedTrial, userLogado]);

    useEffect(() => {
        const rawPath = window.location.pathname;
        const path = rawPath.length > 1 && rawPath.endsWith('/') ? rawPath.slice(0, -1) : rawPath;
        const unblock =
            publicLinksWithoutModalBlocking.some((l) =>
                typeof l === 'string' ? l === path : l.test(path),
            ) ||
            privateLinksWithoutModalBlocking.some((l) =>
                typeof l === 'string' ? l === path : l.test(path),
            );
        if (unblock) {
            setShowModalBloqueio(false);
            setShowModalBloqueioTesteGratis(false);
            setShowModalBloqueioLiberacao(false);
            setShowModalBloqueioPlanos(false);
        }
    }, [showModalBloqueio, showModalBloqueioTesteGratis, showModalBloqueioLiberacao, showModalBloqueioPlanos, publicLinksWithoutModalBlocking, privateLinksWithoutModalBlocking]);

    useEffect(() => {
        localStorage.setItem('is404', 'false');
    }, []);

    const linksWithNewHeader = [
        '/',
        '/cupom-indique-e-ganhe',
        '/nova-farm',
        '/caderno-campo',
        '/produtores',
        '/compendio',
        '/compra',
        '/historico',
        '/relatorios',
        '/indique-e-ganhe',
        /^\/fazendas\/\d+\/\d+$/,
        '/comprar_receitas',
        '/agronomos',
        /^\/agronomos\/\d+$/,
        '/arts',
        //TOTVS
        '/solicitacoes-receitas',
        '/credenciais-defesas',
        '/configurar-produtos',
        '/notas-fiscais',
    ];

    const linkWithNewHeader = linksWithNewHeader.some(link =>
        (typeof link === "string" ? link === currentPath : link.test(currentPath))
    );
    const forceHideByPath = shouldStartHidden(currentPath);
    const effectiveHide = forceHideByPath || (typeof props.routeConfig?.showMenu === 'boolean'
        ? !props.routeConfig.showMenu
        : hide);

    const validateUserIndique = async () => {
        localStorage.setItem("@open", "true")

        try {
            const response = await api.get('/usuario-cupom')

            if (response.data.data === true) {
                return (window.location = '/cupom-indique-e-ganhe')
            } else {
                return (window.location = '/indique-e-ganhe')
            }
        } catch (error) { }
    }

    const [showProfile, setShowProfile] = useState(true);
    const [isTotvsPerm4CompanyHover, setIsTotvsPerm4CompanyHover] = useState(false);
    const [isTotvsPerm4UsersHover, setIsTotvsPerm4UsersHover] = useState(false);
    const [isTotvsPerm4ConfigHover, setIsTotvsPerm4ConfigHover] = useState(false);
    const [isTotvsPerm4DefesasHover, setIsTotvsPerm4DefesasHover] = useState(false);
    const [isTotvsPerm4WebhookHover, setIsTotvsPerm4WebhookHover] = useState(false);
    const userData = JSON.parse(localStorage.getItem("@userinfo"));
    const [userPlanId, setUserPlanId] = useState(0);
    const [diasRestantes, setDiasRestantes] = useState(0);

    const [qtdNotification, setQtdNotification] = useState(
        () => parseInt(localStorage.getItem('@notif_count') ?? '0', 10) || 0
    );

    const updateQtdNotification = (value) => {
        setQtdNotification(value);
        localStorage.setItem('@notif_count', String(value));
    };

    useEffect(() => {
        if (userData?.contrato) {
            setUserPlanId(userData.contrato.agro_plan_config.agro_plan_id);
            setDiasRestantes(userData.contrato.dias_restantes);
        }
    }, []);


    useEffect(() => {
        if (logged === true || logged === 'true') {
            const fetchQtdNotification = async () => {
                try {
                    const response = await api.get('/notificacoes/quantidade');
                    updateQtdNotification(response.data?.data ?? 0);
                } catch { }
            };
            fetchQtdNotification();
            const interval = setInterval(fetchQtdNotification, 5 * 60 * 1000);
            return () => clearInterval(interval);
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            setWidth(currentWidth);
            setShowProfile(currentWidth < 767);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>

            {isMobile === false && effectiveHide === false && (
                <BtnMinimize onClick={() => minimizeMenu()} isOpen={isOpen}>
                    <Seta open={isOpen} />
                </BtnMinimize>
            )}

            <NavBarContainer
                ref={ref}
                hide={effectiveHide}
                isMobile={isMobile}
                isOpen={isOpen}
            >

                {isMobile === true && effectiveHide === false ? (
                    <HeadMenu button={isTest || isPrePago}>
                        <div className='line-2'>
                            {isMobile && (
                                planId === 1 ? (
                                    <Logo1 width={150} style={{ width: '180px', height: "100%" }} onClick={() => window.location = '/planos'} />
                                ) : planId === 6 && (
                                    <Logo6 width={150} style={{ width: '180px', height: "100%" }} onClick={() => window.location = '/planos'} />
                                )
                            )}
                        </div>

                        <div className='line-1'>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: "0.5rem" }}>

                                {showProfile && (
                                    <div style={{ marginLeft: "0.3rem" }}>

                                        <ProfileMenu
                                            userData={userData}
                                            planId={userPlanId}
                                            diasRestantes={diasRestantes}
                                            isMobile={isMobile}
                                        />
                                    </div>
                                )}
                                <S.ContainerNotification>
                                    {width <= 760 && !isTotvs() && (
                                        <a href="/notificacao">
                                            <img src={Notificacao} alt="Icone de notificação" />
                                            {qtdNotification > 0 && (
                                                <S.NotifCountBadge>
                                                    {qtdNotification > 9 ? '9+' : qtdNotification}
                                                </S.NotifCountBadge>
                                            )}
                                        </a>
                                    )}
                                </S.ContainerNotification>

                            </div>

                            {
                                planId === 4 ? (
                                    <Logo4 width={150} style={{ width: '180px', height: "100%" }} onClick={() => window.location = '/planos'} />
                                ) : planId === 5 ? (
                                    <Logo5 width={150} style={{ width: '180px', height: "100%" }} />
                                ) : planId === 7 ? (
                                    <Logo7 width={150} style={{ width: '180px', height: "100%" }} onClick={() => window.location = '/planos'} />
                                ) : planId === 9 ?
                                    (
                                        <div style={{ width: '235px', height: '50px', display: 'flex', justifyContent: 'center' }}>
                                            <img src={LogoBranca} alt='Logo AgroReceita Branco' />
                                        </div>
                                    ) : (null)
                            }
                        </div>

                    </HeadMenu>
                ) : (
                    <>
                        {effectiveHide === true ? (null) : (
                            <HeadMenu isOpenMenu={isOpen}>
                                <div onClick={() => { if (!isTotvs) goToHome() }}>
                                    {isOpen ? (
                                        <>
                                            {userStatusContrato === 'EN' ? (
                                                <img src={Logo} alt="logo" onClick={() => redirectTo("/", 8)} />
                                            ) : (planId === 1 ? (
                                                <Logo1 width={200} />
                                            ) : (planId === 2 ? (
                                                <Logo2 width={200} />
                                            ) : (planId === 3 ? (
                                                <Logo3 width={200} />
                                            ) : (planId === 4 ? (
                                                <Logo4 width={200} />
                                            ) : (planId === 5 ? (
                                                <Logo5 width={200} />
                                            ) : (planId === 6 ? (
                                                <Logo6 width={200} />
                                            ) : (planId === 7 ? (
                                                <Logo7 width={200} />
                                            ) : (isTotvs() ? (
                                                <div style={{ width: '190px', display: 'flex', justifyContent: 'center' }}>
                                                    <img src={LogoBranca} alt='Logo AgroReceita Branco' />
                                                </div>
                                            ) : (
                                                null
                                            )))))))))}
                                        </>
                                    ) : (
                                        <img src={logomini} width='33px' height='33px' alt='Logo Agroreceita' />
                                    )}
                                </div>
                            </HeadMenu>
                        )}
                    </>
                )}
                <Items>
                    {isTotvs() ? (
                        user.agro_permission_id === 4 ? (
                            <>
                                {/* --- MINHA EMPRESA --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/filiais' ? true : false}
                                    onClick={() => redirectTo('/filiais')}
                                    onMouseEnter={() => setIsTotvsPerm4CompanyHover(true)}
                                    onMouseLeave={() => setIsTotvsPerm4CompanyHover(false)}
                                >
                                    {pathname === '/filiais' || isTotvsPerm4CompanyHover ? (
                                        <img
                                            src={iconCompanyTotvsWhite}
                                            alt="Minha Empresa"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                            className="hover-icon"
                                        />
                                    ) : (
                                        <img
                                            src={iconCompanyTotvsGray}
                                            alt="Minha Empresa"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    )}

                                    {isOpen && (
                                        <>
                                            <label>MINHA EMPRESA</label>
                                        </>
                                    )}
                                    <p>Minha Empresa</p>
                                </ItemMenu>

                                {/* --- USUÁRIOS --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/usuarios' ? true : false}
                                    onClick={() => redirectTo('/usuarios')}
                                    onMouseEnter={() => setIsTotvsPerm4UsersHover(true)}
                                    onMouseLeave={() => setIsTotvsPerm4UsersHover(false)}
                                >
                                    {pathname === '/usuarios' || isTotvsPerm4UsersHover ? (
                                        <img
                                            src={iconUsersTotvsWhite}
                                            alt="Usuários"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    ) : (
                                        <img
                                            src={iconUsersTotvsGray}
                                            alt="Usuários"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    )}

                                    {isOpen && (
                                        <>
                                            <label>USUÁRIOS</label>
                                        </>
                                    )}
                                    <p>Usuários</p>
                                </ItemMenu>

                                {/* --- CONFIGURAR PRODUTOS --- (não se aplica ao plano Omie) */}
                                {!isOmie() && (
                                    <ItemMenu
                                        isOpenMenu={isOpen}
                                        active={pathname === '/configurar-produtos' ? true : false}
                                        onClick={() => redirectTo('/configurar-produtos')}
                                        onMouseEnter={() => setIsTotvsPerm4ConfigHover(true)}
                                        onMouseLeave={() => setIsTotvsPerm4ConfigHover(false)}
                                    >
                                        {pathname === '/configurar-produtos' || isTotvsPerm4ConfigHover ? (
                                            <img
                                                src={iconConfigWhite}
                                                alt="Configurar Produtos"
                                                width='20px'
                                                style={{ marginRight: "13px" }}
                                            />
                                        ) : (
                                            <img
                                                src={iconConfigGray}
                                                alt="Configurar Produtos"
                                                width='20px'
                                                style={{ marginRight: "13px" }}
                                            />
                                        )}

                                        {isOpen && (
                                            <>
                                                <label>CONFIGURAR PRODUTOS</label>
                                            </>
                                        )}
                                        <p>Configurar Produtos</p>
                                    </ItemMenu>
                                )}



                                {/* --- CREDENCIAIS DEFESAS --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/credenciais-defesas' ? true : false}
                                    onClick={() => redirectTo('/credenciais-defesas')}
                                    onMouseEnter={() => setIsTotvsPerm4DefesasHover(true)}
                                    onMouseLeave={() => setIsTotvsPerm4DefesasHover(false)}
                                >
                                    {pathname === '/credenciais-defesas' || isTotvsPerm4DefesasHover ? (
                                        <img
                                            src={iconSecurityUserWhite}
                                            alt="Defesas"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    ) : (
                                        <img
                                            src={iconSecurityUserGray}
                                            alt="Defesas"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    )}

                                    {isOpen && (
                                        <>
                                            <label>CREDENCIAIS DEFESAS</label>
                                        </>
                                    )}
                                    <p>Credenciais Defesas</p>
                                </ItemMenu>

                                {/* --- INTEGRAÇÃO PROTHEUS --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/integracao-webhook' ? true : false}
                                    onClick={() => redirectTo('/integracao-webhook')}
                                    onMouseEnter={() => setIsTotvsPerm4WebhookHover(true)}
                                    onMouseLeave={() => setIsTotvsPerm4WebhookHover(false)}
                                >
                                    {pathname === '/integracao-webhook' || isTotvsPerm4WebhookHover ? (
                                        <img
                                            src={iconGlobalTotvsWhite}
                                            alt="Integração Webhook"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    ) : (
                                        <img
                                            src={iconGlobalTotvsGray}
                                            alt="Integração Webhook"
                                            width='20px'
                                            style={{ marginRight: "13px" }}
                                        />
                                    )}

                                    {isOpen && (
                                        <>
                                            <label>INTEGRAÇÃO WEBHOOK</label>
                                        </>
                                    )}
                                    <p>Integração Webhook</p>
                                </ItemMenu>

                            </>
                        ) : (
                            <>
                                {/* --- INÍCIO --- */}
                                <ItemMenu
                                    active={pathname === '/' ? true : false}
                                    onClick={() => redirectTo('/', 2)}
                                    isOpenMenu={isOpen}

                                >
                                    <IconHome />
                                    {isOpen && (
                                        <>
                                            <label>INÍCIO</label>
                                        </>
                                    )}

                                    <p>Início</p>
                                </ItemMenu>

                                {/* --- RECEITUARIO --- */}
                                <ItemMenu
                                    active={
                                        pathname === '/receitas/add' ||
                                            pathname === '/receitas/addlote' ||
                                            pathname === '/compendio' ||
                                            pathname === '/solicitacoes-receitas' ||
                                            pathname === '/historico' ||
                                            pathname === '/guia_aplicacao' ||
                                            pathname === '/solicitar' ||
                                            pathname === '/exportar-defesas' ||
                                            pathname === '/relatorios' ? true : openReceituario ? true : false}
                                    onClick={() => openMenu(1)}
                                    isOpen={openReceituario}
                                    className="receituario"
                                    isOpenMenu={isOpen}
                                >
                                    <IconReceita />
                                    {isOpen && (
                                        <>
                                            <label>RECEITUÁRIO</label>
                                            <img src={Arrow} alt='seta' className='arrow' />
                                        </>
                                    )}
                                    <p>Receituário</p>
                                </ItemMenu>

                                <DropSubItems open={pathname === '/receitas/add' || pathname === '/receitas/addlote' || pathname === '/compendio' || pathname === '/historico' || pathname === '/guia_aplicacao' || pathname === '/exportar-defesas' ? true : openReceituario ? true : false}>
                                    <SubItem
                                        open={pathname === '/receitas/add' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/receitas/add' ? true : false}
                                        onClick={() => { redirectTo('/receitas/add'); localStorage.setItem("reloadEmissao", "true") }}
                                        className="emitirR"
                                    >
                                        <label>EMITIR RECEITA</label>
                                    </SubItem>

                                    <SubItem
                                        open={pathname === '/receitas/addlote' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/receitas/addlote' ? true : false}
                                        onClick={() => { redirectTo('/receitas/addlote'); localStorage.setItem("reloadEmissaoLote", "true") }}
                                        className="emitirR"
                                    >
                                        <label>EMITIR RECEITA EM LOTE</label>
                                    </SubItem>

                                    <SubItem
                                        open={pathname === '/solicitacoes-receitas' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/solicitacoes-receitas' ? true : false}
                                        onClick={() => { redirectTo('/solicitacoes-receitas'); localStorage.setItem("reloadSolicitacoes", "true") }}
                                        className="emitirR"
                                    >
                                        <label>SOLICITAÇÕES DE RECEITAS</label>
                                    </SubItem>

                                    {showExportarDefesas ? (
                                        <SubItem
                                            open={pathname === '/exportar-defesas' ? openReceituario ? true : false : openReceituario ? true : false}
                                            active={pathname === '/exportar-defesas' ? true : false}
                                            onClick={() => {
                                                const user = JSON.parse(localStorage.getItem(USER));
                                                if (user && user.contrato.agro_plan_config.agro_plan_id === 1) {
                                                    setShowModalBlockDefesas(true);
                                                } else {
                                                    redirectTo('/exportar-defesas');
                                                    if (exportNotificationStatus === 1) {
                                                        api.post('/notificacoes/exportacao/dispensar').then(() => {
                                                            setExportNotificationStatus(0);
                                                        }).catch(err => console.error(err));
                                                    }
                                                }
                                            }}
                                            style={{ position: 'relative' }}
                                        >
                                            <label>EXPORTAR PARA DEFESAS</label>
                                            {exportNotificationStatus === 1 && <NotificationBadge />}
                                        </SubItem>
                                    ) : (null)}

                                    <SubItem
                                        open={pathname === '/notas-fiscais' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/notas-fiscais' ? true : false}
                                        onClick={() => redirectTo('/notas-fiscais')}
                                    >
                                        <label>NOTAS FISCAIS</label>
                                    </SubItem>

                                    <SubItem
                                        open={pathname === '/compendio' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/compendio' ? true : false}
                                        onClick={() => redirectTo('/compendio')}
                                    >
                                        <label>COMPÊNDIO</label>
                                    </SubItem>

                                    <SubItem
                                        open={pathname === '/historico' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/historico' ? true : false}
                                        onClick={() => redirectTo('/historico')}

                                    >
                                        <label>HISTÓRICO</label>
                                    </SubItem>

                                    {/* <SubItem
                                    open={pathname === '/solicitar' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/solicitar' ? true : false}
                                    onClick={() => redirectTo('/solicitar')}
                                >
                                    <label>SOLICITAR PRODUTO</label>
                                </SubItem> */}

                                    {/* <SubItem
                                    open={pathname === '/guia_aplicacao' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/guia_aplicacao' ? true : false}
                                    onClick={() => redirectTo('/guia_aplicacao')}
                                >
                                    <label>GUIA DE APLICAÇÃO</label>
                                </SubItem> */}

                                    <SubItem
                                        open={pathname === '/relatorios' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/relatorios' ? true : false}
                                        onClick={() => redirectTo('/relatorios')}
                                    >
                                        <label>RELATÓRIOS</label>
                                    </SubItem>
                                </DropSubItems>

                                {/* --- RESPONSAVEIS TECNICOS --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={
                                        pathname === '/agronomos' ||
                                            pathname === '/agronomos/:id' ||
                                            pathname === '/agronomos/add' ||
                                            pathname === '/arts' ||
                                            pathname === '/arts/:id' ||
                                            pathname === '/arts/add' ||
                                            pathname === '/contracts/:id' ||
                                            pathname === '/editcontract/:id' ||
                                            pathname === '/newcontract/:id' ? true : openResponsavel ? true : false
                                    }
                                    onClick={() => openMenu(2)}
                                    isOpen={openResponsavel}
                                >
                                    <IconResponsavel
                                        width='22px'
                                    />
                                    {isOpen && (
                                        <>
                                            <label>RESPONSÁVEIS TÉCNICOS</label>
                                            <img src={Arrow} alt='seta' className='arrow' />
                                        </>
                                    )}
                                    <p>Responsáveis Técnicos</p>
                                </ItemMenu>

                                <DropSubItems open={openResponsavel}>
                                    <SubItem
                                        open={openResponsavel}
                                        active={
                                            pathname === '/agronomos' ||
                                                pathname === '/agronomos/:id' ||
                                                pathname === '/agronomos/add' ? true : false
                                        }
                                        onClick={() => redirectTo('/agronomos')}
                                    >
                                        <label>RESPONSÁVEIS TÉCNICOS</label>
                                    </SubItem>

                                    <SubItem
                                        open={openResponsavel}
                                        active={
                                            pathname === '/arts' ||
                                                pathname === '/arts/:id' ||
                                                pathname === '/arts/add' ||
                                                pathname === '/contracts/:id' ||
                                                pathname === '/editcontract/:id' ||
                                                pathname === '/newcontract/:id' ? true : false
                                        }
                                        onClick={() => redirectTo('/arts')}
                                    >
                                        <label>ARTs/TRT</label>
                                    </SubItem>
                                </DropSubItems>

                                {/* --- PRODUTORES --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={
                                        pathname === '/produtores' ||
                                            pathname === '/produtores/:id' ||
                                            pathname === '/produtores/add' ? true : openProdutor ? true : false
                                    }
                                    onClick={() => openMenu(3)}
                                    isOpen={openProdutor}
                                >
                                    <IconProdutor />
                                    {isOpen && (
                                        <>
                                            <label>PRODUTORES</label>
                                            <img src={Arrow} alt='seta' className='arrow' />
                                        </>
                                    )}
                                    <p>Produtores</p>
                                </ItemMenu>

                                <DropSubItems open={openProdutor}>
                                    <SubItem
                                        open={openProdutor}
                                        active={
                                            pathname === '/produtores' ||
                                                pathname === '/produtores/:id' ||
                                                pathname === '/produtores/add' ? true : false
                                        }
                                        onClick={() => redirectTo('/produtores')}
                                    >
                                        <label>PRODUTORES</label>
                                    </SubItem>

                                    {/* <SubItem 
                                    open={openProdutor}
                                    active={
                                        pathname === '/fazendas' || 
                                        pathname === '/fazendas/:idfazenda/:idprodutor' || 
                                        pathname === '/localdeaplicacao/add/:id' ? true : false
                                    }
                                    onClick={() => redirectTo('/fazendas')}
                                >
                                    <label>LOCAIS DE APLICAÇÃO</label>
                                </SubItem> */}

                                    <SubItem
                                        open={openProdutor}
                                        active={
                                            pathname === '/devolucoes' ||
                                                pathname === '/devolucoes/:id' ||
                                                pathname === '/devolucoes/add' ? true : false
                                        }
                                        onClick={() => redirectTo('/devolucoes')}
                                    >
                                        <label>LOCAIS DE DEVOLUÇÃO</label>
                                    </SubItem>
                                </DropSubItems>

                                {/* --- CALENDARIO --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/caderno-campo' ? true : false}
                                    onClick={() => redirectTo('/caderno-campo')}
                                >
                                    <IconSchedule
                                        width='22px'
                                    />
                                    {isOpen && (
                                        <>
                                            <label>CADERNO DE CAMPO</label>
                                        </>
                                    )}
                                    <p>Caderno de Campo</p>
                                </ItemMenu>

                                {/* --- CRM ---
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={pathname === '/crm' ? true : false}
                                onClick={() => redirectTo('/crm')}
                            >
                                <IconCrm />
                                {isOpen && (
                                    <>
                                        <label>OPORTUNIDADES NEGÓCIOS</label>
                                    </>
                                )}
                                <p>Oportunidades Negócios</p>
                            </ItemMenu> */}

                                {/* --- FISPQ + FE --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={pathname === '/documentos_seguranca' ? true : false}
                                    onClick={() => redirectTo('/documentos_seguranca')}
                                >
                                    <IconFicha />
                                    {isOpen && (
                                        <>
                                            <label>EMITIR FDS/FISPQ E FICHA DE EMERGÊNCIA</label>
                                        </>
                                    )}
                                    <p>EMITIR FDS/FISPQ E FICHA DE EMERGÊNCIA</p>
                                </ItemMenu>

                                {/* --- EXTRAS --- */}
                                <ItemMenu
                                    isOpenMenu={isOpen}
                                    active={
                                        pathname === '/extras/nova_receita' ? true : openExtras ? true : false
                                    }
                                    onClick={() => openMenu(4)}
                                    isOpen={openExtras}
                                >
                                    <IconExtra />
                                    {isOpen && (
                                        <>
                                            <label>EXTRAS</label>
                                            <img src={Arrow} alt='seta' className='arrow' />
                                        </>
                                    )}
                                    <p>Extras</p>
                                </ItemMenu>

                                <DropSubItems open={openExtras}>
                                    <SubItem
                                        open={openExtras}
                                        active={pathname === '/blog' ? true : false}
                                        onClick={() => redirectTo('/blog')}
                                    >
                                        {/* <IconBlog /> */}
                                        <label>BLOG AGRORECEITA</label>
                                    </SubItem>

                                    <SubItem
                                        open={openExtras}
                                        active={false}
                                        onClick={() => redirectToBlank('https://sudeste-online.s3.amazonaws.com/ra-extras/Check%20List%20Receitu%C3%A1rio.pdf')}
                                    >
                                        <label>CHECK LIST DA RECEITA</label>
                                    </SubItem>

                                    {/* <SubItem
                                    open={openExtras}
                                    active={false}
                                    onClick={() => validateUserIndique()}
                                >
                                    <label>INDIQUE E GANHE</label>
                                </SubItem> */}

                                    <SubItem
                                        open={openExtras}
                                        active={false}
                                        onClick={() => redirectToBlank('https://sudeste-online.s3.amazonaws.com/ra-extras/Infogr%C3%A1fico%20T%C3%A9cnico%20Agr%C3%ADcola.pdf')}
                                    >
                                        <label>TÉCNICO AGRÍCOLA</label>
                                    </SubItem>

                                    {/* <SubItem
                                    open={openExtras}
                                    active={
                                        pathname === '/extras/nova_receita' ? true : false
                                    }
                                    onClick={() => redirectTo('/extras/nova_receita')}
                                >
                                    <label>NOVA EMISSÃO DE RECEITA</label>
                                </SubItem> */}
                                </DropSubItems>

                                {isOpen ? (
                                    <ImgGooglePlay >
                                        <Tooltip disabled={isMobile} placement="top" interactive={false} delay={[100, 0]} content={
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <img className='tippyImage' src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://play.google.com/store/apps/details?id=com.clienteagroreceita')}`} alt="QR Google Play" style={{ width: '140px', height: '140px' }} />
                                                <span style={{ marginTop: '8px', fontFamily: 'Lato', fontSize: '12px', color: theme.colors.gray.Cinza_2 }}>Baixar agora</span>
                                            </div>
                                        }>
                                            <a href='https://play.google.com/store/apps/details?id=com.clienteagroreceita' target='_blank'>
                                                <img src={DispGooglePlay} />
                                            </a>
                                        </Tooltip>

                                        <Tooltip disabled={isMobile} placement="top" interactive={false} delay={[100, 0]} content={
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <img className='tippyImage' src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B4mica/id1671808311')}`} alt="QR App Store" style={{ width: '140px', height: '140px' }} />
                                                <span style={{ marginTop: '8px', fontFamily: 'Lato', fontSize: '12px', color: theme.colors.gray.Cinza_2 }}>Baixar agora</span>
                                            </div>
                                        }>
                                            <a className='img-2' href='https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B4mica/id1671808311' target='_blank'>
                                                <img src={DispAppStore} />
                                            </a>
                                        </Tooltip>
                                    </ImgGooglePlay>
                                ) : (
                                    null
                                )}
                            </>
                        )
                    ) : (
                        <>
                            {/* --- INÍCIO --- */}
                            <ItemMenu
                                active={pathname === '/' ? true : false}
                                onClick={() => redirectTo('/', 2)}
                                isOpenMenu={isOpen}

                            >
                                <IconHome />
                                {isOpen && (
                                    <>
                                        <label>INÍCIO</label>
                                    </>
                                )}

                                <p>Início</p>
                            </ItemMenu>

                            {/* --- RECEITUARIO --- */}
                            <ItemMenu
                                active={
                                        pathname.startsWith("/receitas/add") ||
                                        pathname.startsWith("/receitas/addlote") ||
                                        pathname === '/compendio' ||
                                        pathname === '/solicitacoes-receitas' ||
                                        pathname === '/historico' ||
                                        pathname === '/guia_aplicacao' || 
                                        pathname === '/solicitar' ||
                                        pathname === '/relatorios' ? true : openReceituario ? true : false}
                                onClick={() => openMenu(1)}
                                isOpen={openReceituario}
                                className="receituario"
                                isOpenMenu={isOpen}
                            >
                                <IconReceita />
                                {isOpen && (
                                    <>
                                        <label>RECEITUÁRIO</label>
                                        <img src={Arrow} alt='seta' className='arrow' />
                                    </>
                                )}
                                <p>Receituário</p>
                            </ItemMenu>

                            <DropSubItems open={pathname === '/receitas/add' || pathname === '/compendio' || pathname === '/historico' || pathname === '/guia_aplicacao' ? true : openReceituario ? true : false}>
                                <SubItem
                                    open={pathname === '/receitas/add' || pathname.startsWith("/receitas/add") ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/receitas/add' || pathname.startsWith("/receitas/add/") ? true : false}
                                    onClick={() => { redirectTo('/receitas/add'); localStorage.setItem("reloadEmissao", "true") }}
                                    className="emitirR"
                                >
                                    <label>EMITIR RECEITA</label>
                                </SubItem>

                                <SubItem
                                    open={pathname === '/receitas/addlote' || pathname.startsWith("/receitas/addlote") ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/receitas/addlote' || pathname.startsWith("/receitas/addlote") ? true : false}
                                    onClick={() => { redirectTo('/receitas/addlote'); localStorage.setItem("reloadEmissaoLote", "true") }}
                                    className="emitirR"
                                >
                                    <label>EMITIR RECEITA EM LOTE</label>
                                </SubItem>

                                {showExportarDefesas ? (
                                    <SubItem
                                        open={pathname === '/exportar-defesas' ? openReceituario ? true : false : openReceituario ? true : false}
                                        active={pathname === '/exportar-defesas' ? true : false}
                                        onClick={() => {
                                            const user = JSON.parse(localStorage.getItem(USER));
                                            if (user && user.contrato.agro_plan_config.agro_plan_id === 1) {
                                                setShowModalBlockDefesas(true);
                                            } else {
                                                redirectTo('/exportar-defesas');
                                                if (exportNotificationStatus === 1) {
                                                    api.post('/notificacoes/exportacao/dispensar').then(() => {
                                                        setExportNotificationStatus(0);
                                                    }).catch(err => console.error(err));
                                                }
                                            }
                                        }}
                                        style={{ position: 'relative' }}
                                    >
                                        <label>EXPORTAR PARA DEFESAS</label>
                                        {exportNotificationStatus === 1 && <NotificationBadge />}
                                    </SubItem>
                                ) : (null)}

                                <SubItem
                                    open={pathname === '/compendio' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/compendio' ? true : false}
                                    onClick={() => redirectTo('/compendio')}
                                >
                                    <label>COMPÊNDIO</label>
                                </SubItem>

                                <SubItem
                                    open={pathname === '/historico' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/historico' ? true : false}
                                    onClick={() => redirectTo('/historico')}

                                >
                                    <label>HISTÓRICO</label>
                                </SubItem>

                                <SubItem
                                    open={pathname === '/solicitar' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/solicitar' ? true : false}
                                    onClick={() => redirectTo('/solicitar')}
                                >
                                    <label>SOLICITAR PRODUTO</label>
                                </SubItem>

                                <SubItem
                                    open={pathname === '/guia_aplicacao' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/guia_aplicacao' ? true : false}
                                    onClick={() => redirectTo('/guia_aplicacao')}
                                >
                                    <label>GUIA DE APLICAÇÃO</label>
                                </SubItem>

                                <SubItem
                                    open={pathname === '/relatorios' ? openReceituario ? true : false : openReceituario ? true : false}
                                    active={pathname === '/relatorios' ? true : false}
                                    onClick={() => redirectTo('/relatorios')}
                                >
                                    <label>RELATÓRIOS</label>
                                </SubItem>

                            </DropSubItems>

                            {/* --- RESPONSAVEIS TECNICOS --- */}
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={
                                    pathname === '/agronomos' ||
                                        pathname === '/agronomos/:id' ||
                                        pathname === '/agronomos/add' ||
                                        pathname === '/arts' ||
                                        pathname === '/arts/:id' ||
                                        pathname === '/arts/add' ||
                                        pathname === '/contracts/:id' ||
                                        pathname === '/editcontract/:id' ||
                                        pathname === '/newcontract/:id' ||
                                        pathname.startsWith("/agronomos/") ||
                                        pathname.startsWith("/arts/") ||
                                        pathname.startsWith('/contracts/') ||
                                        pathname.startsWith('/editcontract/') ||
                                        pathname.startsWith('/newcontract/') ? true : openResponsavel ? true : false
                                }
                                onClick={() => openMenu(2)}
                                isOpen={openResponsavel}
                            >
                                <IconResponsavel
                                    width='22px'
                                />
                                {isOpen && (
                                    <>
                                        <label>RESPONSÁVEIS TÉCNICOS</label>
                                        <img src={Arrow} alt='seta' className='arrow' />
                                    </>
                                )}
                                <p>Responsáveis Técnicos</p>
                            </ItemMenu>

                            <DropSubItems open={openResponsavel}>
                                <SubItem
                                    open={openResponsavel}
                                    active={
                                        pathname === '/agronomos' ||
                                            pathname === '/agronomos/:id' ||
                                            pathname === '/agronomos/add' ||
                                            pathname.startsWith("/agronomos/") ? true : false
                                    }
                                    onClick={() => redirectTo('/agronomos')}
                                >
                                    <label>RESPONSÁVEIS TÉCNICOS</label>
                                </SubItem>

                                <SubItem
                                    open={openResponsavel}
                                    active={
                                        pathname === '/arts' ||
                                            pathname === '/arts/:id' ||
                                            pathname === '/arts/add' ||
                                            pathname === '/contracts/:id' ||
                                            pathname === '/editcontract/:id' ||
                                            pathname === '/newcontract/:id' ||
                                            pathname.startsWith("/arts/") ||
                                            pathname.startsWith('/contracts/') ||
                                            pathname.startsWith('/editcontract/') ||
                                            pathname.startsWith('/newcontract/')  ? true : false
                                    }
                                    onClick={() => redirectTo('/arts')}
                                >
                                    <label>ARTs/TRT</label>
                                </SubItem>
                            </DropSubItems>


                            {/* --- PRODUTORES --- */}
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={
                                    pathname === '/produtores' ||
                                        pathname === '/produtores/:id' ||
                                        pathname === '/produtores/add' ||
                                        pathname === '/devolucoes' ||
                                        pathname === '/devolucoes/:id' ||
                                        pathname === '/devolucoes/add' ||
                                        pathname.startsWith("/produtores/") ||
                                        pathname.startsWith("/devolucoes/") ? true : openProdutor ? true : false
                                }
                                onClick={() => openMenu(3)}
                                isOpen={openProdutor}
                            >
                                <IconProdutor />
                                {isOpen && (
                                    <>
                                        <label>PRODUTORES</label>
                                        <img src={Arrow} alt='seta' className='arrow' />
                                    </>
                                )}
                                <p>Produtores</p>
                            </ItemMenu>

                            <DropSubItems open={openProdutor}>
                                <SubItem
                                    open={openProdutor}
                                    active={
                                        pathname === '/produtores' ||
                                            pathname === '/produtores/:id' ||
                                            pathname === '/produtores/add' ||
                                            pathname.startsWith("/produtores/") ? true : false
                                    }
                                    onClick={() => redirectTo('/produtores')}
                                >
                                    <label>PRODUTORES</label>
                                </SubItem>

                                {/* <SubItem 
                            open={openProdutor}
                            active={
                                pathname === '/fazendas' || 
                                pathname === '/fazendas/:idfazenda/:idprodutor' || 
                                pathname === '/localdeaplicacao/add/:id' ? true : false
                            }
                            onClick={() => redirectTo('/fazendas')}
                        >
                            <label>LOCAIS DE APLICAÇÃO</label>
                        </SubItem> */}

                                <SubItem
                                    open={openProdutor}
                                    active={
                                        pathname === '/devolucoes' ||
                                            pathname === '/devolucoes/:id' ||
                                            pathname === '/devolucoes/add' ||
                                            pathname.startsWith("/devolucoes/") ? true : false
                                    }
                                    onClick={() => redirectTo('/devolucoes')}
                                >
                                    <label>LOCAIS DE DEVOLUÇÃO</label>
                                </SubItem>
                            </DropSubItems>

                            {/* --- CALENDARIO --- */}
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={pathname === '/caderno-campo' ? true : false}
                                onClick={() => redirectTo('/caderno-campo')}
                            >
                                <IconSchedule
                                    width='22px'
                                />
                                {isOpen && (
                                    <>
                                        <label>CADERNO DE CAMPO</label>
                                    </>
                                )}
                                <p>Caderno de campo</p>
                            </ItemMenu>

                            {/* --- CRM ---
                    <ItemMenu
                        isOpenMenu={isOpen}
                        active={pathname === '/crm' ? true : false}
                        onClick={() => redirectTo('/crm')}
                    >
                        <IconCrm />
                        {isOpen && (
                            <>
                                <label>OPORTUNIDADES NEGÓCIOS</label>
                            </>
                        )}
                        <p>Oportunidades Negócios</p>
                    </ItemMenu> */}

                            {/* --- FISPQ + FE --- */}
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={pathname === '/documentos_seguranca' ? true : false}
                                onClick={() => redirectTo('/documentos_seguranca')}
                            >
                                <IconFicha />
                                {isOpen && (
                                    <>
                                        <label>EMITIR FDS/FISPQ E FICHA DE EMERGÊNCIA</label>
                                    </>
                                )}
                                <p>EMITIR FDS/FISPQ E FICHA DE EMERGÊNCIA</p>
                            </ItemMenu>


                            {/* --- EXTRAS --- */}
                            <ItemMenu
                                isOpenMenu={isOpen}
                                active={
                                    pathname === '/extras/nova_receita' ||
                                        pathname === '/blog' ||
                                        pathname === '/cupom-indique-e-ganhe' ? true : openExtras ? true : false
                                }
                                onClick={() => openMenu(4)}
                                isOpen={openExtras}
                            >
                                <IconExtra />
                                {isOpen && (
                                    <>
                                        <label>EXTRAS</label>
                                        <img src={Arrow} alt='seta' className='arrow' />
                                    </>
                                )}
                                <p>Extras</p>
                            </ItemMenu>

                            <DropSubItems open={openExtras}>
                                
                                <SubItem
                                    open={openExtras}
                                    active={pathname === '/cupom-indique-e-ganhe' ? true : false}
                                    onClick={() => validateUserIndique()}
                                >
                                    <label>INDIQUE E GANHE</label>
                                </SubItem>

                                <SubItem
                                    open={openExtras}
                                    active={false}
                                    onClick={() => redirectToBlank('https://agroreceita.com.br/blog')}
                                >
                                    {/* <IconBlog /> */}
                                    <label>BLOG AGRORECEITA</label>
                                </SubItem>

                                <SubItem
                                    open={openExtras}
                                    active={false}
                                    onClick={() => redirectToBlank('https://sudeste-online.s3.amazonaws.com/ra-extras/Check%20List%20Receitu%C3%A1rio.pdf')}
                                >
                                    <label>CHECK LIST DA RECEITA</label>
                                </SubItem>

                                <SubItem
                                    open={openExtras}
                                    active={false}
                                    onClick={() => redirectToBlank('https://sudeste-online.s3.amazonaws.com/ra-extras/Infogr%C3%A1fico%20T%C3%A9cnico%20Agr%C3%ADcola.pdf')}
                                >
                                    <label>TÉCNICO AGRÍCOLA</label>
                                </SubItem>

                                {/* <SubItem
                            open={openExtras}
                            active={
                                pathname === '/extras/nova_receita' ? true : false
                            }
                            onClick={() => redirectTo('/extras/nova_receita')}
                        >
                            <label>NOVA EMISSÃO DE RECEITA</label>
                        </SubItem> */}
                            </DropSubItems>

                            {isOpen ? (
                                <ImgGooglePlay >
                                    <Tooltip disabled={isMobile} placement="top" interactive={true} delay={[100, 0]} content={
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <img className='tippyImage' src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://play.google.com/store/apps/details?id=com.clienteagroreceita')}`} alt="QR Google Play" style={{ width: '140px', height: '140px' }} />
                                            <span style={{ marginTop: '8px', fontFamily: 'Lato', fontSize: '12px', color: theme.colors.gray.Cinza_2 }}>Baixar agora</span>
                                        </div>
                                    }>
                                        <a href='https://play.google.com/store/apps/details?id=com.clienteagroreceita' target='_blank'>
                                            <img src={DispGooglePlay} />
                                        </a>
                                    </Tooltip>
                                    <Tooltip disabled={isMobile} placement="top" interactive={true} delay={[100, 0]} content={
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <img className='tippyImage' src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B4mica/id1671808311')}`} alt="QR App Store" style={{ width: '140px', height: '140px' }} />
                                            <span style={{ marginTop: '8px', fontFamily: 'Lato', fontSize: '12px', color: theme.colors.gray.Cinza_2 }}>Baixar agora</span>
                                        </div>
                                    }>
                                        <a className='img-2' href='https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B4mica/id1671808311' target='_blank'>
                                            <img src={DispAppStore} />
                                        </a>
                                    </Tooltip>
                                </ImgGooglePlay>
                            ) : (
                                null
                            )}
                        </>
                    )
                    }
                </Items>

                <FooterMenu isOpenMenu={isOpen}>
                    {/* --- AJUDA --- */}
                    <ItemFootMenu
                        active={false}
                        onClick={() => redirectToBlank('https://agroreceita.com.br/central-de-ajuda/')}
                        style={{
                            backgroundColor: "#1D2129"
                        }}
                        isOpenMenu={isOpen}
                    >
                        <IconBuoy />
                        {isOpen && (
                            <>
                                <label>CENTRAL DE AJUDA</label>
                            </>
                        )}

                        <p>Central de ajuda</p>

                    </ItemFootMenu>

                    {isOpen && (
                        <>
                            <Terms>
                                <label onClick={() => openModelTerm()}>Termos de uso</label>
                                <label onClick={() => openPolicyTerm()}>Politica de privacidade</label>
                            </Terms>
                        </>
                    )}

                </FooterMenu>
            </NavBarContainer>

            {isMobile === true && effectiveHide === false ? (
                <>
                    {isOpen === false && hasInlineMenuButton === false ? (
                        <>
                            {console.log("EXIBIU")}
                            <MenuHamburg
                                isBlackNovember={isBlackNovember}
                                hasTopBanner={hasTopBanner}
                                onClick={() => openMenuByHamburger()}
                                style={{
                                    display:
                                        props.location.pathname === '/login' ? 'none' :
                                            props.location.pathname === '/compra/sucesso' ||
                                                props.location.pathname === '/compra/sucesso/compra-5' ||
                                                props.location.pathname === '/compra/sucesso/compra-4' ||
                                                props.location.pathname === '/compra/sucesso/compra-7' ||
                                                props.location.pathname === '/compra/sucesso/compra-6' ? 'none' :
                                                props.location.pathname === '/novo-cadastro' ? 'none' :
                                                    props.location.pathname === '/novo-cadastro-email' ? 'none' :
                                                        props.location.pathname === '/novo-cadastro-completo' ? 'none' : 'flex'
                                }}>

                                {linkWithNewHeader ? (
                                    <img src={MenuHamburgerBlack} alt='menu' onClick={() => openMenuByHamburger()} />
                                ) : (
                                    //apagar depois e mudar a lógica
                                    <img src={MenuHamburgerBlack} alt='menu' onClick={() => openMenuByHamburger()} />
                                )
                                }
                            </MenuHamburg>
                        </>

                    ) : (null)}
                </>
            ) : (
                <>
                    {effectiveHide === false ? (
                        <>

                            <ButtonNewP
                                isBlackNovember={isBlackNovember}
                                onClick={() => window.location = "/receitas/add"}
                                show={
                                    props.location.pathname === '/' ? false : false
                                }
                                isPro={planId == 5 ? true : false}
                                isTest={planId == 1 ? true : false}
                            >
                                <p style={{ cursor: 'pointer' }}>NOVA RECEITA</p>
                            </ButtonNewP>

                            {/* {linkWithNewHeader ? ('') : (
                                <Upgrade
                                    isBlackNovember={isBlackNovember}
                                    show={props.location.pathname === '/login' ?
                                        false : props.location.pathname === '/compra/sucesso' ?
                                            false : props.location.pathname.search(logincompra) !== -1 ?
                                                false : props.location.pathname.search(simulacaocompra) !== -1 ?
                                                    false : props.location.pathname === '/relatorios' ?
                                                        false : isTest ?
                                                            false : planId == 5 ?
                                                                false : true
                                    }
                                    onClick={() => redirectTo('/planos')}
                                >
                                    <p onClick={() => redirectTo('/planos')}>ATUALIZAR PLANO</p>
                                </Upgrade>
                            )} */}

                            {/* <Userinfo
                                isBlackNovember={isBlackNovember}
                                showOptions={openUserOptions}
                                planId={planId}
                                updateOpenUserOptions={(e) => setOpenUserOptions(e)}
                                redirectTo={(e) => redirectTo(e, 10)}
                                location={props.location.pathname}
                            /> */}



                            {!linkWithNewHeader ? (
                                <S.ContainerProfileAndNotification hasPromo={isBlackNovember} hasTopBanner={hasTopBanner}>
                                    <S.ContainerNotificationV2>
                                        {width > 760 && !isTotvs() && (
                                            <a href="/notificacao">
                                                <img src={Notificacao} alt="Ícone de notificação" />
                                                {qtdNotification > 0 && (
                                                    <S.NotifCountBadge>
                                                        {qtdNotification > 9 ? '9+' : qtdNotification}
                                                    </S.NotifCountBadge>
                                                )}
                                            </a>
                                        )}
                                    </S.ContainerNotificationV2>

                                    <S.ContainerProfile>
                                        <ProfileMenu
                                            userData={userData}
                                            planId={userPlanId}
                                            diasRestantes={diasRestantes}
                                            isMobile={isMobile}
                                        />
                                    </S.ContainerProfile>
                                </S.ContainerProfileAndNotification>
                            ) : ("")}
                        </>
                    ) : (null)}
                </>
            )}

            {/* <Notification
                show={localStorage.getItem('is404') === 'true' ? false :
                    props.location.pathname === '/login' ?
                        false : props.location.pathname === '/compra/sucesso' ?
                            false : props.location.pathname === '/cadastro/sucesso' ?
                                false : props.location.pathname.startsWith('/senha') ?
                                    false : props.location.pathname === '/cadastro' ?
                                        false : props.location.pathname === '/validador' ?
                                            false : props.location.pathname === '/cadastro/site' ?
                                                false : props.location.pathname === '/compendio-gratis' ?
                                                    false : props.location.pathname.search(logincompra) !== -1 ?
                                                        false : props.location.pathname === '/receituario-agronomico-2026' ?
                                                            false : props.location.pathname === '/black-november-2024' ?
                                                                false : props.location.pathname === '/apresentacao' ?
                                                                    false : props.location.pathname === '/planos' ?
                                                                        false : props.location.pathname === '/indique-e-ganhe' ?
                                                                            false : props.location.pathname === '/cupom-indique-e-ganhe' ?
                                                                                false : props.location.pathname === '/compendio' ?
                                                                                    false : props.location.pathname.search(simulacaocompra) !== -1 ?
                                                                                        //Telas front 2.0
                                                                                        false : props.location.pathname === '/' ?
                                                                                            false : props.location.pathname === '/nova-farm' ?
                                                                                                    // false : props.location.pathname === '/novo-login' ?
                                                                                                    // false : props.location.pathname === '/novo-cadastro' ?
                                                                                                    false : props.location.pathname === '/cadastro-email' ?
                                                                                                        false : props.location.pathname === '/cadastro-completo' ?
                                                                                                            false : props.location.pathname === '/cadastro/sucesso' ?
                                                                                                                false : props.location.pathname === '/nova-home/apresentacao' ?
                                                                                                                    false : props.location.pathname === '/caderno-campo' ?
                                                                                                                        false : props.location.pathname === '/historico' ?
                                                                                                                            false : props.location.pathname.startsWith('/compra') ?
                                                                                                                                false : props.location.pathname === '/produtores' ?
                                                                                                                                    false : props.location.pathname.startsWith('/fazendas') ?
                                                                                                                                        //Telas antigas sem a notificação antiga
                                                                                                                                        false : props.location.pathname === '/receitas/add' ?
                                                                                                                                            false : props.location.pathname === '/notificacao' ?
                                                                                                                                                false : props.location.pathname === '/receitas/addlote' ?
                                                                                                                                                    false : props.location.pathname === '/solicitar' ?
                                                                                                                                                        false : props.location.pathname === '/guia_aplicacao' ?
                                                                                                                                                            false : props.location.pathname === '/relatorios' ?
                                                                                                                                                                false : props.location.pathname === '/agronomos' ?
                                                                                                                                                                    false : props.location.pathname === '/arts' ?
                                                                                                                                                                        false : props.location.pathname === '/devolucoes' ?
                                                                                                                                                                            false : props.location.pathname === '/documentos_seguranca' ?
                                                                                                                                                                                false : props.location.pathname === '/blog' ?
                                                                                                                                                                                    false : props.location.pathname === '/extras/nova_receita' ?
                                                                                                                                                                                        false : props.location.pathname === '/agronomos' ?
                                                                                                                                                                                            false : TextTrackCueList
                }
                onClick={() => redirectTo('/notificacao')}
                isMobile={isMobile}
                isTest={isTest}
                isPro={planId == 5 ? true : false}
                tremer={qtd_notification > 0 ? true : false}
                isBlackNovember={isBlackNovember}
            >
                {qtd_notification > 0 ? (<NumNotifications>{qtd_notification}</NumNotifications>) : (null)}
                <IconNotification onClick={() => redirectTo('/notificacao')} />
            </Notification> */}

            {isMobile && !isOpen && !hide ? (
                <NavbarMobile />
            ) : null}

            <ModalTermosUso
                show={showModalTermo}
                btnOk={true}
                onHide={() => setShowModalTermo(!showModalTermo)}
            ></ModalTermosUso>

            <ModalPolitica
                show={showModalPolitica}
                btnOk={true}
                onHide={() => setShowModalPolitica(!showModalPolitica)}
            ></ModalPolitica>

            <ModalTextSession
                show={showModalSession}
                onHide={() => closeSession()}
                btnOk={true}
                text="Outra sessão foi iniciada em outro dispositivo."
                update={() => closeSession()}
            ></ModalTextSession>

            <ModalBloqueio
                show={showModalBloqueio}
                onHide={() => goToHome()}
                size='lg'
            >
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                    <p
                        style={{
                            fontFamily: 'Lato',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            fontStretch: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center',
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        {titleModal}
                    </p>

                    <div
                        style={{
                            color: '#303848',
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center',
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {messageModal}
                    </div>
                </div>
            </ModalBloqueio>

            <ModalBloqueio
                show={showModalBloqueioTesteGratis}
                onHide={() => goToHome()}
                size='sm'
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-around',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <p
                        style={{
                            fontFamily: 'Lato',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            fontStretch: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {titleModal}
                    </p>

                    <div
                        style={{
                            color: '#303848',
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {messageModal}
                    </div>

                </div>
            </ModalBloqueio>

            <ModalBloqueio
                show={showModalBloqueioLiberacao}
                onHide={() => goToHome()}
                size='mg'
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-around',
                        flexDirection: 'column'
                    }}
                >
                    <p
                        style={{
                            fontFamily: 'Lato',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            fontStretch: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {titleModal}
                    </p>

                    <p
                        style={{
                            color: '#303848',
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {messageModal}
                    </p>

                    <div
                        classname='items'
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-around'
                        }}
                    >
                        {modalItems.map((i) => (
                            <p>{i}</p>
                        ))}
                    </div>

                    <div style={{ marginLeft: '10px', width: '100%', textAlign: 'center', marginTop: '20px', alignSelf: 'center', display: 'flex', justifyContent: 'space-around', flexDirection: 'row-reverse' }}>
                        <Button style={{ outline: 0, padding: "5px", width: "166px", height: "45px" }}
                            color="#00b43f"
                            onClick={() => goToHome()}
                        >ENTENDI</Button>
                    </div>
                </div>
            </ModalBloqueio>

            <ModalBloqueio
                show={showModalBloqueioPlanos}
                onHide={() => goToHome()}
                size='mg'
            >
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                    <p
                        style={{
                            fontFamily: 'Lato',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            fontStretch: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {titleModal}
                    </p>

                    <p
                        style={{
                            color: '#303848',
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            width: '100%',
                            textAlign: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {messageModal}
                    </p>

                    <div
                        classname='items'
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-around'
                        }}
                    >
                        {modalItems.map((i) => (
                            <p>{i}</p>
                        ))}
                    </div>

                    <div style={{ marginLeft: '10px', width: '100%', textAlign: 'center', marginTop: '20px', alignSelf: 'center', display: 'flex', justifyContent: 'space-around', flexDirection: 'row-reverse' }}>
                        <Button style={{ outline: 0, padding: "5px", width: "166px", height: "45px" }}
                            color="#00b43f"
                            onClick={() => goToHome()}
                        >ENTENDI</Button>
                    </div>
                </div>
            </ModalBloqueio>

            <ModalBloqueio
                show={showModalCancelado}
                onHide={() => goToHome()}
                size='mg'
            >
                {userLogado && publicLinksModalBlockedOff === false ? (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                        <p
                            style={{
                                fontFamily: 'Lato',
                                fontSize: '22px',
                                fontWeight: 'bold',
                                fontStretch: 'normal',
                                width: '100%',
                                textAlign: 'center',
                                alignSelf: 'center'
                            }}
                        >
                            {titleModal}
                        </p>

                        <p
                            style={{
                                color: '#303848',
                                fontFamily: 'Lato',
                                fontSize: '16px',
                                fontWeight: 'normal',
                                width: '100%',
                                textAlign: 'center',
                                alignSelf: 'center'
                            }}
                        >
                            {messageModal}
                        </p>

                        <div
                            classname='items'
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-around'
                            }}
                        >
                            {modalItems.map((i) => (
                                <p>{i}</p>
                            ))}
                        </div>

                        <div style={{ marginLeft: '10px', width: '100%', textAlign: 'center', marginTop: '20px', alignSelf: 'center', display: 'flex', justifyContent: 'space-around', flexDirection: 'row-reverse' }}>
                            <Button style={{ outline: 0, padding: "5px", width: "166px", height: "45px" }}
                                color="#00b43f"
                                onClick={() => goToHome()}
                            >ENTENDI</Button>
                        </div>
                    </div>
                ) : (null)}
            </ModalBloqueio>

            <ModalBloqueio
                show={showModalHoje}
                onHide={() => showModalHojeFalse()}
                size='mg'
                marginBottom='0'
            >
                {userLogado && publicLinksModalBlockedOff === false ? (
                    <S.Container>
                        <img src={ModalImage} alt='Imagem garota olhando um presente' />

                        <H5 color={theme.colors.gray.Cinza_5}>Seu teste grátis termina hoje!</H5>

                        <BodyG color={theme.colors.gray.Cinza_5}>
                            Assine agora mesmo utilizando o cupom <BodyGSpan color={theme.colors.red.Vermelho_erro}>BEMVINDO</BodyGSpan> e garanta <BodyGSpan color={theme.colors.red.Vermelho_erro}>90% de desconto</BodyGSpan> na primeira mensalidade dos planos Basic, Light ou Pro ou <BodyGSpan color={theme.colors.red.Vermelho_erro}>20% de desconto</BodyGSpan> na sua primeira compra de créditos Pré-pago.
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_6}>
                            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                        </Auxiliar>

                        <S.ButtonPlans>
                            <ButtonV2
                                width='90%'
                                height='60px'
                                value='Ver Planos'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlansWithCupomHoje()}
                                loading={false}
                            ></ButtonV2>
                        </S.ButtonPlans>
                    </S.Container>
                ) : (null)}
            </ModalBloqueio>

            <ModalTermos
                show={showTerms}
                termos={true}
                title="Atualização dos Termos de Uso"
                text={["Atualizamos os Termos e Condições de Uso da plataforma AgroReceita.", " Para continuar utilizando o sistema, é necessário ler e aceitar os novos termos"]}
                btnOk={true}
                onHide={closeTerms}
                update={updateTerms}
            ></ModalTermos>

            <ModalTermos
                show={showUpdateTerms}
                termos={true}
                title="Olá, seja bem vindo!"
                text={["Atualizamos nossos termos de uso!", 'para continuar confirme sua leitura']}
                btnOk={true}
                onHide={closeTerms}
                update={updateTerms}
                noHeader
            ></ModalTermos>

            <ModalGeneric
                show={showDelayedModal}
                onHide={() => showModalFalse()}
                marginBottom='0'
            >
                {userLogado && publicLinksModalBlockedOff === false ? (
                    <S.Container>
                        <img src={ModalImage} alt='Imagem garota olhando um presente' />

                        <H5>Seu teste grátis expira em {userLogado.contrato.dias_restante} dia(s)</H5>

                        <BodyG>
                            Assine agora mesmo utilizando o cupom <BodyGSpan color={theme.colors.red.Vermelho_erro}>BEMVINDO</BodyGSpan> e garanta <BodyGSpan color={theme.colors.red.Vermelho_erro}>90% de desconto</BodyGSpan> na primeira mensalidade dos planos Basic, Light ou Pro ou <BodyGSpan color={theme.colors.red.Vermelho_erro}>20% de desconto</BodyGSpan> na sua primeira compra de créditos Pré-pago.
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_6}>
                            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                        </Auxiliar>

                        <S.ButtonPlans>
                            <ButtonV2
                                width='90%'
                                height='60px'
                                value='Ver Planos'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlansWithCupom()}
                                loading={false}
                            ></ButtonV2>
                        </S.ButtonPlans>
                    </S.Container>
                ) : (null)}
            </ModalGeneric>

            {showModalBlockDefesas && (
                <ModalGeneric show={showModalBlockDefesas} onHide={() => setShowModalBlockDefesas(false)}>
                    <S.Container>
                        <img src={ModalImageRecursoCliente} alt='Celular com formulário' />

                        <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes</H5>

                        <BodyG color={theme.colors.gray.Cinza_5}>
                            Esta função está disponível apenas para clientes. Para desbloquear essa e outras funcionalidades, faça já seu upgrade.
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_6}>
                            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                        </Auxiliar>

                        <div
                            style={{
                                width: '100%',
                                maxWidth: '350px',
                                margin: 'auto',
                                marginTop: '20px',
                                alignSelf: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >

                            <ButtonV2
                                width='296px'
                                height='50px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => {
                                    setShowModalBlockDefesas(false);
                                    goToPlans();
                                }}
                                loading={false}
                            />
                        </div>
                    </S.Container>
                </ModalGeneric>
            )}
        </>
    )
}

export default withRouter(Navbar);
